<template>
  <div>
    <div
      class="pt-3 white-wrapper add-multiple-schedule add-multiple-schedule-v3"
      v-if="isScheduleAdded == false"
    >
      <div class="row">
        <div class="col-md-3 mb-2">
          <div>
            <b-dropdown
              :disabled="isRoleID || isScheduleAdded"
              :text="selected.cinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Cinema"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)"
                  v-on:keydown="onSearchCinema($event.target.value)"
                  v-on:search="onSearchCinema($event.target.value)"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in CinemasList"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>

        <div class="col-md-3 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker disable-dates-class">
                <button
                  class="btn-clearDate"
                  v-if="
                    movieSelected.ss_start_date && isScheduleAdded === false
                  "
                  v-on:click="clear_ss_start_date()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  :disabled="isScheduleAdded"
                  ref="programaticOpen"
                  placeholder="Start Date"
                  v-model="movieSelected.ss_start_date"
                  @selected="onSelectStartDate($event, 'start')"
                  name="showstartdate"
                  id="showstartdate"
                  v-validate="'required'"
                  :typeable="true"
                ></Datepicker>
                <label :class="movieSelected.ss_start_date ? 'd-none' : ''"
                  >Start Date</label
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker disable-dates-class">
                <Datepicker
                  :monday-first="true"
                  disabled
                  placeholder="End Date"
                  ref="programaticOpen"
                  v-model="movieSelected.ss_end_date"
                  name="showenddate"
                  id="showenddate"
                  v-validate="'required'"
                  :typeable="true"
                ></Datepicker>
                <label :class="movieSelected.ss_end_date ? 'd-none' : ''"
                  >End Date</label
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-2 float-right">
          <div
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            v-if="colorCollapse"
            @click="collapseColorCodes()"
            v-b-toggle="'colorCodes'"
            :title="'Schedule Overview'"
          ></div>
          <div
            class="icon-collapse blue-icon mx-1 btn float-right"
            v-if="!colorCollapse"
            @click="collapseColorCodes()"
            v-b-toggle="'colorCodes'"
            :title="'Schedule Overview'"
          ></div>
        </div>
      </div>
      <b-collapse :id="'colorCodes'" class="">
        <div class="col-lg-12 col-xl-12 mt-1">
          <div class="d-flex">
            <div
              class="color-coding d-flex flex-wrap w-100"
              v-if="typeList.length > 0"
            >
              <div
                class="pr-3 mb-2"
                v-for="(type, typeIndex) in typeList"
                :key="typeIndex"
              >
                <div
                  class="d-flex justify-content-center align-items-center"
                  v-if="
                    [
                      'overlapError',
                      'rateCardError',
                      'plannedToSchedule',
                      'scheduleToPlanned',
                      'schedule-checked',
                      'planned-checked',
                    ].includes(type.class)
                  "
                >
                  <div class="">
                    <div :class="type.class">
                      <b-form-checkbox
                        type="checkbox"
                        class="j-checkbox pointer-events"
                        :checked="
                          ['schedule-checked', 'planned-checked'].includes(
                            type.class
                          )
                        "
                        :unchecked-value="false"
                        :value="true"
                        @click="(e) => e.preventDefault()"
                      ></b-form-checkbox>
                    </div>
                  </div>
                  <div class="color-combination ml-1">
                    {{ type.name }}
                  </div>
                </div>
                <div
                  class="d-flex justify-content-center align-items-center"
                  v-else-if="
                    ['add_movie', 'add_show_time'].includes(type.class)
                  "
                >
                  <div
                    class="d-flex justify-content-center align-items-center"
                    v-if="type.class == 'add_movie'"
                  >
                    <div class="key-box">Shift</div>
                    +
                    <div class="key-box">M</div>
                  </div>
                  <div
                    class="d-flex justify-content-center align-items-center"
                    v-else-if="type.class == 'add_show_time'"
                  >
                    <div class="key-box">Shift</div>
                    +
                    <div class="key-box">Enter</div>
                  </div>
                  <div class="color-combination ml-2">
                    {{ type.name }}
                  </div>
                </div>
                <div
                  class="d-flex justify-content-center align-items-center"
                  v-else
                >
                  <div class="">
                    <div
                      class="color-box-2"
                      :style="'background-color:' + type.color"
                    ></div>
                  </div>
                  <div class="color-combination ml-1">
                    {{ type.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
      <template
        v-if="
          movieSelected.ss_start_date &&
            movieSelected.ss_end_date &&
            scheduleObject.cinema_id
        "
      >
        <div
          class="justify-content-center align-items-center movie-version-box"
          v-for="(screenObj, screenMainIndex) in MultiScheduleArray"
          :key="screenMainIndex"
          :class="screenMainIndex > 0 ? 'mt-3' : ''"
        >
          <div class="row pr-2">
            <div class="col-md-12 col-lg-12 mb-4" v-if="ScreenList.length > 0">
              <div class="ml-2">
                <b-button
                  v-for="(screen, screenIndex) in ScreenList"
                  :key="screenIndex"
                  :class="
                    `mx-1 cursor-pointer custom-button mb-2 custom-button-no-hover`
                  "
                  @click="
                    onSelectScreen($event, screen, screenIndex, screenMainIndex)
                  "
                  :variant="
                    screenObj.screen_id
                      ? screenObj.screen_id == screen.screen_id
                        ? 'success'
                        : 'primary'
                      : 'primary'
                  "
                  v-b-popover.hover.bottom="{
                    customClass: 'screen-popover',
                    content: `
                          <div class='row'>
                            <div class='col-5 mr-0 pr-0 border-bottom'><b>Movie Formats:</b></div>
                            <div class='col-7 ml-0 pl-0 border-bottom'><b>${getSupportedFormats(
                              screen,
                              'mf'
                            )}</b></div>
                            <div class='col-5 mr-0 pr-0'><b>Sound Formats:</b></div>
                            <div class='col-7 ml-0 pl-0'> <b>${getSupportedFormats(
                              screen,
                              'sf'
                            )}</b></div>
                          </div>
                          `,
                    html: true,
                  }"
                  >{{ screen.screen_name }}</b-button
                >
              </div>
            </div>
          </div>

          <div
            class="row align-items-center"
            v-for="(moviesObj, moviesIndex) in screenObj.moviesArray"
            :key="moviesIndex"
            v-if="checkShowArrayLength(moviesIndex)"
            @click="updateCursorIndex(moviesIndex)"
          >
            <div class="movieBox-multi">
              <div
                class="movie-version-inner justify-content-center align-items-center padTop-18"
              >
                <div class="row">
                  <div class="col-3 pr-0">
                    <div class>
                      <div
                        class="dropdown-curve-container custom_movie_selector"
                      >
                        <!-- <label
                          :class="moviesObj.movie_details_id ? 'shift-up' : ''"
                          >Select Movie</label
                        > -->
                        <multiselect
                          v-model="moviesObj.selectedMovie"
                          :disabled="
                            moviesObj.showTimeArray.some((show) =>
                              show.dateArray.some(
                                (date) => date.isDayDisable && date.ss_id
                              )
                            )
                          "
                          :ref="`movie_row_${moviesIndex}`"
                          :id="`movie_row_${moviesIndex}`"
                          :name="`movie_row_${moviesIndex}`"
                          label="movie_name"
                          track-by="md_id"
                          :showLabels="false"
                          placeholder="Select Movie"
                          :options="getFilteredMoviesList || []"
                          :multiple="false"
                          @select="
                            onSelectMovie($event, moviesIndex, screenMainIndex)
                          "
                          select-label="Select"
                          deselect-label="Remove"
                        >
                          <span slot="noResult">Oops! No Results found.</span>
                          <template slot="option" slot-scope="props"
                            ><div
                              :title="props.option.movie_name"
                              v-if="props.option"
                              :class="
                                `${
                                  !props.option.mrrdr_runtime ||
                                  props.option.mrrdr_runtime == 0
                                    ? 'ssmv-red-color'
                                    : ''
                                }`
                              "
                            >
                              <!-- <span v-if="props.option.movie_version" class="text-truncate" style="font-size: 11px !important">{{ props.option.movie_version }}</span>&nbsp; -->
                              <div
                                style="font-size: 12px !important"
                                class="font-weight-bold movieNameTag"
                              >
                                {{ props.option.movie_title }}
                              </div>
                              <p
                                class="movieVersionTag text-muted"
                                v-if="props.option.movie_version"
                              >
                                {{ props.option.movie_version }}
                              </p>
                            </div>
                            <!-- <br />
                            <span
                              v-if="props.option"
                              class="text-truncate"
                              style="font-size: 11px !important"
                              >{{ props.option.movie_version }}</span
                            > -->
                          </template>
                        </multiselect>
                      </div>

                      <p
                        v-if="submitted && moviesObj.selectedMovie.length == 0"
                        class="error_message"
                      >
                        {{ msgmovie }}
                      </p>
                      <p
                        v-if="submitted && moviesObj.formatError"
                        class="error_message"
                      >
                        {{ $t("videoFormatError") }}
                      </p>
                      <p
                        v-if="submitted && moviesObj.soundFormatError"
                        class="error_message"
                      >
                        {{ $t("soundFormatError") }}
                      </p>
                      <p
                        v-if="submitted && moviesObj.licenseDateError"
                        class="warning_message"
                      >
                        {{ $t("licenseDateError") }}
                      </p>
                    </div>
                  </div>
                  <div class="col-9 pl-1">
                    <div
                      v-for="(showTimeObj,
                      showTimeIndex) in moviesObj.showTimeArray"
                      :key="showTimeIndex"
                      v-if="showTimeObj.is_active == 'Y'"
                      class="show_time_row border-bottom"
                    >
                      <div class="row align-items-center">
                        <div class="col-11">
                          <div class="row align-items-center">
                            <div class="col-3 px-1">
                              <div
                                class="d-flex justify-content-center align-items-center mln18"
                              >
                                <!-- <customTimePicker
                                  :time="showTimeObj.startTime2"
                                  @getTime="(e) => (showTimeObj.startTime2 = e)"
                                  :disabled="
                                    showTimeObj.dateArray.some(
                                      (date) => date.isDayDisable && date.ss_id
                                    ) ||
                                    !checkValueAdded(
                                      null,
                                      'time',
                                      moviesIndex,
                                      showTimeIndex,
                                      false
                                    )
                                  "
                                  :ref="`showtimeBox${
                                    'M_' + moviesIndex + 'S_' + showTimeIndex
                                  }`"
                                  @focus="
                                    shiftUpDown(
                                      $event,
                                      'focus',
                                      moviesIndex,
                                      showTimeIndex
                                    )
                                  "
                                  @blur="
                                    shiftUpDown(
                                      $event,
                                      'blur',
                                      moviesIndex,
                                      showTimeIndex
                                    );
                                    onChangeShowStartTime(
                                      $event,
                                      screenMainIndex,
                                      moviesIndex,
                                      showTimeIndex
                                    );
                                  "
                                /> -->
                                <div
                                  class="slick-input mr-2"
                                  @click="
                                    checkValueAdded(
                                      $event,
                                      'time',
                                      moviesIndex,
                                      showTimeIndex
                                    )
                                  "
                                >
                                  <div
                                    class="time_picker_custom multiSchTimePicker"
                                    :id="
                                      `showtimeBox${'M_' +
                                        moviesIndex +
                                        'S_' +
                                        showTimeIndex}`
                                    "
                                  >
                                    <vue-timepicker
                                      manual-input
                                      autocomplete="on"
                                      v-model="showTimeObj.startTime2"
                                      hide-dropdown
                                      id="startshowtime"
                                      :ref="
                                        `showtimeBox${'M_' +
                                          moviesIndex +
                                          'S_' +
                                          showTimeIndex}`
                                      "
                                      name="showtime"
                                      format="HH:mm"
                                      class="time_picker"
                                      input-width="100%"
                                      placeholder="Start"
                                      auto-scroll
                                      v-validate="'required'"
                                      :disabled="
                                        showTimeObj.dateArray.some(
                                          (date) =>
                                            date.isDayDisable && date.ss_id
                                        ) ||
                                          !checkValueAdded(
                                            null,
                                            'time',
                                            moviesIndex,
                                            showTimeIndex,
                                            false
                                          )
                                      "
                                      @focus="
                                        shiftUpDown(
                                          $event,
                                          'focus',
                                          moviesIndex,
                                          showTimeIndex
                                        )
                                      "
                                      @blur="
                                        shiftUpDown(
                                          $event,
                                          'blur',
                                          moviesIndex,
                                          showTimeIndex
                                        );
                                        onChangeShowStartTime(
                                          $event,
                                          screenMainIndex,
                                          moviesIndex,
                                          showTimeIndex
                                        );
                                      "
                                    ></vue-timepicker>
                                  </div>
                                </div>
                                <div class="slick-input">
                                  <div
                                    class="time_picker_custom multiSchTimePicker"
                                  >
                                    <vue-timepicker
                                      manual-input
                                      hide-dropdown
                                      v-model="showTimeObj.end_time"
                                      id="endshowtime"
                                      disabled
                                      name="endTime"
                                      format="HH:mm"
                                      class="time_picker text-center"
                                      input-width="100%"
                                      placeholder="End"
                                      auto-scroll
                                      v-validate="'required'"
                                    ></vue-timepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-2 pr-1" v-if="false">
                              <!-- <div
                                class="timepicker-label"
                                v-if="showTimeIndex == 0"
                              >
                                Start time
                              </div> -->
                              <div
                                class="slick-input"
                                @click="
                                  checkValueAdded(
                                    $event,
                                    'time',
                                    moviesIndex,
                                    showTimeIndex
                                  )
                                "
                              >
                                <div
                                  class="time_picker_custom multiSchTimePicker"
                                >
                                  <vue-timepicker
                                    manual-input
                                    v-model="showTimeObj.startTime2"
                                    hide-dropdown
                                    id="showtime"
                                    name="showtime"
                                    format="HH:mm"
                                    class="time_picker"
                                    input-width="100%"
                                    placeholder="Start"
                                    auto-scroll
                                    v-validate="'required'"
                                    :disabled="
                                      showTimeObj.dateArray.some(
                                        (date) =>
                                          date.isDayDisable && date.ss_id
                                      ) ||
                                        !checkValueAdded(
                                          null,
                                          'time',
                                          moviesIndex,
                                          showTimeIndex,
                                          false
                                        )
                                    "
                                    @focus="
                                      shiftUpDown(
                                        $event,
                                        'focus',
                                        moviesIndex,
                                        showTimeIndex
                                      )
                                    "
                                    @blur="
                                      shiftUpDown(
                                        $event,
                                        'blur',
                                        moviesIndex,
                                        showTimeIndex
                                      );
                                      onChangeShowStartTime(
                                        $event,
                                        screenMainIndex,
                                        moviesIndex,
                                        showTimeIndex
                                      );
                                    "
                                  ></vue-timepicker>
                                </div>
                              </div>
                            </div>
                            <div class="col-2 pl-1" v-if="false">
                              <!-- <div
                                class="timepicker-label"
                                v-if="showTimeIndex == 0"
                              >
                                End time
                              </div> -->
                              <div class="slick-input">
                                <div
                                  class="time_picker_custom multiSchTimePicker"
                                >
                                  <vue-timepicker
                                    manual-input
                                    hide-dropdown
                                    v-model="showTimeObj.end_time"
                                    id="showtime"
                                    disabled
                                    name="endTime"
                                    format="HH:mm"
                                    class="time_picker"
                                    input-width="100%"
                                    placeholder="End"
                                    auto-scroll
                                    v-validate="'required'"
                                  ></vue-timepicker>
                                </div>
                              </div>
                            </div>
                            <div class="col-9">
                              <div class="d-flex justify-content-between">
                                <div
                                  class="text-center"
                                  v-for="(day,
                                  dayIndex) in showTimeObj.dateArray"
                                  :key="dayIndex"
                                >
                                  <div
                                    class="font-weight-bold fs-12 date-text"
                                    :class="
                                      day.date != 'Wk'
                                        ? 'date-shift'
                                        : 'no-date-shift'
                                    "
                                    v-if="showTimeIndex == 0"
                                  >
                                    <div>
                                      {{
                                        moment(day.date).isValid()
                                          ? moment(
                                              day.date,
                                              "YYYY-MM-DD"
                                            ).format("DD.MM")
                                          : day.date
                                      }}
                                    </div>
                                    <div v-if="day.date != 'Wk'">
                                      &nbsp;({{
                                        moment(day.date).isValid()
                                          ? moment(
                                              day.date,
                                              "YYYY-MM-DD"
                                            ).format("dd")
                                          : day.date
                                      }})
                                    </div>
                                  </div>
                                  <div
                                    :class="[
                                      {
                                        'planned-checked':
                                          day.selected_schedule_type.id == 19,
                                      },
                                      {
                                        'schedule-checked':
                                          day.selected_schedule_type.id == 16,
                                      },
                                      {
                                        rateCardError:
                                          day.errType == 'R' &&
                                          !day.isDaySelected,
                                      },
                                      {
                                        overlapError:
                                          day.errType == 'O' &&
                                          !day.isDaySelected,
                                      },
                                    ]"
                                    @click="
                                      checkValueAdded(
                                        $event,
                                        'day',
                                        moviesIndex,
                                        showTimeIndex
                                      )
                                    "
                                  >
                                    <b-form-checkbox
                                      type="checkbox"
                                      class="j-checkbox"
                                      v-model="day.isDaySelected"
                                      :disabled="day.isDayDisable"
                                      :class="
                                        day.isDayDisable && day.isDaySelected
                                          ? 'checkBoxDisable'
                                          : ''
                                      "
                                      :unchecked-value="false"
                                      :value="true"
                                      @change="
                                        onClickWeekDays(
                                          $event,
                                          showTimeIndex,
                                          moviesIndex,
                                          day,
                                          dayIndex
                                        )
                                      "
                                    ></b-form-checkbox>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-1 d-flex align-items-center justify-content-center p-0 m-0"
                        >
                          <button
                            class="btn-transparent float-right addBtn_multi"
                            v-if="moviesObj.showTimeArray.length > 1"
                            @click="
                              onRemoveShowTime(
                                screenMainIndex,
                                moviesIndex,
                                showTimeIndex
                              )
                            "
                          >
                            <img
                              src="@/assets/img/icons/delete-black.svg"
                              height="30"
                              width="30"
                            />
                          </button>
                          <template
                            v-if="
                              checkForScheduleTypeBtn(showTimeObj.dateArray)
                            "
                          >
                            <button
                              class="btn-transparent float-left schduleTypeBtn addBtn_multi"
                              :class="
                                checkForScheduleTypeBtn(
                                  showTimeObj.dateArray
                                ) == 1
                                  ? 'type16'
                                  : 'type19'
                              "
                              @click="
                                onChangeShowStatusToSchedule(
                                  screenMainIndex,
                                  moviesIndex,
                                  showTimeIndex,
                                  checkForScheduleTypeBtn(
                                    showTimeObj.dateArray
                                  ) == 1
                                    ? 16
                                    : 19
                                )
                              "
                              v-b-popover.hover.left="{
                                customClass: `ZoomClass9`,
                                content: `Change Planned Schedules to Scheduled`,
                                html: true,
                              }"
                            >
                              <span
                                v-if="
                                  checkForScheduleTypeBtn(
                                    showTimeObj.dateArray
                                  ) == 1
                                "
                                >{{ "S" }}</span
                              >
                              <span v-else>{{ "P" }}</span>
                            </button>
                          </template>
                          <template v-else>
                            <div
                              class="btn-transparent float-left schduleTypeBtn-transparent"
                              @click="(e) => e.preventDefault()"
                            ></div>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                    >
                      <button
                        v-if="
                          !checkForPastDate(
                            moment(movieSelected.ss_end_date).format(
                              'DD-MM-YYYY'
                            )
                          )
                        "
                        @click="onAddShowTimePlus(screenMainIndex, moviesIndex)"
                        class="btn-transparent add-more-button addBtn_multi"
                      >
                        <img
                          src="@/assets/img/icons/plus.svg"
                          height="24"
                          width="24"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mx-auto">
              <button
                class="btn-transparent float-right addBtn_multi"
                v-if="screenObj.moviesArray.length > 1"
                @click="onRemoveMovies(screenMainIndex, moviesIndex)"
                style=""
              >
                <img
                  src="@/assets/img/icons/delete-black.svg"
                  height="30"
                  width="30"
                />
              </button>
            </div>
          </div>
          <div
            class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
          >
            <button
              v-if="
                !checkForPastDate(
                  moment(movieSelected.ss_end_date).format('DD-MM-YYYY')
                )
              "
              @click="onAddMoviePlus(screenMainIndex)"
              class="btn-transparent add-more-button addBtn_multi"
            >
              <img src="@/assets/img/icons/plus.svg" height="24" width="24" />
            </button>
          </div>
        </div>
        <div class="col-lg-12 text-center mt-4">
          <button
            @click.prevent.stop="onSubmitMultiSchedule()"
            class="btn-blue"
          >
            Save Schedules
          </button>
          <button
            v-if="checkedPlannedSchedule && false"
            @click.prevent.stop="makeAllPlannedScheduleActive()"
            class="btn-blue"
          >
            Schedule All Planned
          </button>
          <!-- <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button> -->
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="view-schedule"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </template>
      <div
        v-else
        class="d-flex justify-content-center align-items-center"
        :style="'min-height: 250px;'"
      >
        <div class="text-center">
          <div class="icon-empty-folder"></div>
          <div class="font-weight-bold fs-18">Please Select Cinema & Dates</div>
        </div>
      </div>
    </div>
    <b-modal
      id="unsavedConfirmation"
      ref="unsavedConfirmation"
      title="Alert!"
      size="sm"
      hide-footer
      @hidden="closeDialogBeforeLeave()"
      centered
    >
      <div class="font-weight-bold">
        <p>You have unsaved changes. Do you want to save ?</p>
      </div>
      <div class="grpBtns text-right ZoomClass9">
        <button
          class="btn btn-sm btn-secondary"
          @click.prevent.stop="discardChanges()"
        >
          Discard
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-sm btn-primary px-4 fs-14"
          @click.prevent.stop="onSubmitMultiSchedule()"
        >
          Save
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import scheduleService from "@/services/scheduleService";
  import MasterService from "@/services/MasterService";
  import moment from "moment";
  import { BASEURL } from "@/config/index.js";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import _ from "lodash";

  function getInitialData() {
    return {
      clearErrorTime: null,
      cursorIndex: null,
      old_data_from_server: [],
      unsavedChanges: false,
      colorCollapse: false,
      typeList: [
        {
          id: 1,
          name: "Schedule",
          color: "#32bea6",
          class: "schedule-checked",
        },
        {
          id: 2,
          name: "Planned",
          color: "#feff00",
          class: "planned-checked",
        },
        {
          id: 3,
          name: "Overlaped Schedule",
          color: "#feff00",
          class: "overlapError",
        },
        {
          id: 4,
          name: "Rate Card Slot Missing",
          color: "#feff00",
          class: "rateCardError",
        },
        {
          id: 5,
          name: "Change Planned To Schedule",
          color: "#feff00",
          class: "plannedToSchedule",
        },
        {
          id: 6,
          name: "Change Schedule To Planned",
          color: "#feff00",
          class: "scheduleToPlanned",
        },
        {
          id: 7,
          name: "Add Show Time",
          color: "#feff00",
          class: "add_show_time",
        },
        {
          id: 8,
          name: "Add Movie",
          color: "#feff00",
          class: "add_movie",
        },
      ],
      schedule_settings: {
        default_sch_type_id: 19,
        default_selected_schedule: {
          type: "Planned Scheduled",
          id: 19,
        },
        show_all_movies_list: "N",
      },
      scheduleTypeArray: [
        {
          type: "Scheduled",
          id: 16,
        },
        {
          type: "Planned Scheduled",
          id: 19,
        },
      ],
      aggregatorUsersList: [],
      AddonChargesArray: [],
      isSearchLoading: false,
      selectedScreenId: null,
      selectedScreen: "",
      searchValue: "",
      searchCinema: "",
      searchScreen: "",
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      DetailMovie: {
        movie_title: "Movie Name",
        lang_name: "Language",
        mf_name: "Format",
        sound_format_name: "Sound Format",
        lengthMinutes: "Run Time",
        start_time: "Start Time",
        end_time: "End Time",
        interval_time_in_mins: "Interval Time",
        cleaning_time_in_mins: "Cleaning Time",
        ads_time_in_mins: "Advertisement Time",
      },
      showTimeObj: {},
      timeZone: {
        tz_name: "",
        tz_utc_offset: "",
      },
      isScheduleAdded: false, // this blocks the date selector when the schedule is added for the first time
      topValue: 0,
      isRoleID: true, // HO Manager and Super Admin, this is set to false to select any Cinema
      display_time: "",
      intervalsArray: [],
      submitted: false,
      msgcinema: "Please Select Cinema",
      msgscreen: "Please Select Screen",
      msgmovie: "Please Select Movie",
      msgratecard: "Please Select Rate Card",
      // disabledDates: {
      //   to: new Date(2019, 9, 26)
      // },
      selectedMovie: [],
      selected_movie: "Select movie",
      selectedScreen: "Select a screen",
      selectedCinema: "Selected Cinema",
      selected_rate_card: undefined,
      rateCard: {},
      baseURL: BASEURL,
      movieSelectedIndex: null,
      newMovieSelected: [],
      movieSelected: {
        ss_start_date: "",
        ss_end_date: "",
        lang_name: "",
        md_id: 12,
        md_thumbnail_url: "/uploads/movies/1566220586425-dummy.jpg",
        mf_name: "",
        movie_id: 0,
        movie_is_active: "Y",
        movie_title: "",
        mrrdr_runtime: 0,
        selected_time_copy: "",
        sound_format_name: "",
        interval_time_in_mins: "",
        cleaning_time_in_mins: "",
        ads_time_in_mins: "",
      },
      selectedMovieIndex: null,
      selectedScreenIndex: null,
      //
      lists: {
        movies: [],
        cinemas: {
          list: [],
          selectedCinema: {
            cine_name: "select cinema",
          },
        },
        screens: [],
      },
      selectedNewDate: "",
      initialSelectedScreen: "Screen 2",
      silderOne: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 7,
      },
      silderTwo: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 5,
      },
      dropLocation: {
        screen: "",
        hour: "",
        minute: "",
      },
      draggedObject: {
        screen: "",
        length: "",
        oldStart: "",
        newStart: "",
        movie: "",
      },
      selectedMoviesInScreens: [],

      // Saif

      showScheduleCard: false,
      selectedScreenSeatTypes: [],
      selectedRateCardObject: {},

      CinemasList: [],
      CinemasListCopy: [],
      MoviesList: [],
      ScreenList: [],
      ScreenListCopy: [],
      RatecardsList: [],
      RatecardsListCopy: [],
      CinemasSettings: {
        cine_setting_id: null,
        cine_id: null,
        cine_operation_start_time: null,
        cine_operation_end_time: null,
        cine_cleaning_time_in_mins: null,
        cine_setting_ads_time_in_mins: null,
        cine_interval_time_in_mins: null,
        cine_seat_release_time_in_mins: null,
        cine_cutoff_time_in_mins: null,
        cine_setting_is_active: "Y",
        cine_time_zone: "",
      },
      selected: {
        cinema: "Select Cinema",
        screen_name: "Select Screen",
        cinemaObject: {},
      },
      scheduleObject: {
        cinema_id: null,
        sch_start_date: null,
        sch_end_date: null,
        sch_is_active: "Y",
      },
      MultiScheduleArray: [
        {
          screen_id: "",
          screen_name: "Select Screen",
          selectedScreen: "",
          moviesArray: [],
        },
      ],
      alreadyExistArray: [],
      moment,
      checkForUnsavedChanges: false,
    };
  }

  export default {
    components: { VueTimepicker },

    data() {
      return getInitialData();
    },
    watch: {
      "showTimeObj.startTime2": function(newVal, oldVal) {
        console.log("newVal", newVal);
        console.log("oldVal", oldVal);
      },
    },
    computed: {
      // checkForUnsavedChanges() {
      //   let oldtempArray = _.cloneDeep(this.MultiScheduleArray);
      //   let newtempArray = _.cloneDeep(this.old_data_from_server);

      //   if (this.old_data_from_server && this.old_data_from_server.length) {
      //     oldtempArray[0].moviesArray.forEach((movie) => {
      //       Object.keys(movie).map((key) => {
      //         if (
      //           !["showTimeArray", "movie_details_id", "is_active"].includes(key)
      //         ) {
      //           delete movie[key];
      //         }
      //       });
      //       movie.showTimeArray.forEach((show) => {
      //         Object.keys(show).map((key) => {
      //           if (
      //             !["dateArray", "start_time", "end_time", "is_active"].includes(
      //               key
      //             )
      //           ) {
      //             delete show[key];
      //           }
      //         });
      //         show.dateArray.forEach((date) => {
      //           delete date.scheduling_price;
      //           date.start_time = moment(date.start_time, "HH:mm").format(
      //             "HH:mm"
      //           );
      //           date.end_time = moment(date.end_time, "HH:mm").format("HH:mm");
      //         });
      //       });
      //     });

      //     newtempArray[0].moviesArray.forEach((movie) => {
      //       Object.keys(movie).map((key) => {
      //         if (
      //           !["showTimeArray", "movie_details_id", "is_active"].includes(key)
      //         ) {
      //           delete movie[key];
      //         }
      //       });
      //       movie.showTimeArray.forEach((show) => {
      //         Object.keys(show).map((key) => {
      //           if (
      //             !["dateArray", "start_time", "end_time", "is_active"].includes(
      //               key
      //             )
      //           ) {
      //             delete show[key];
      //           }
      //         });
      //         show.dateArray.forEach((date) => {
      //           delete date.scheduling_price;
      //           date.start_time = moment(date.start_time, "HH:mm").format(
      //             "HH:mm"
      //           );
      //           date.end_time = moment(date.end_time, "HH:mm").format("HH:mm");
      //         });
      //       });
      //     });

      //     console.log(oldtempArray, "oldtempArray");
      //     console.log(newtempArray, "newtempArray");

      //     if (JSON.stringify(oldtempArray) == JSON.stringify(newtempArray)) {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   } else {
      //     return true;
      //   }
      // },
      checkedPlannedSchedule() {
        return this.MultiScheduleArray[0].moviesArray.some((movie) =>
          movie.showTimeArray.some((show) =>
            show.dateArray.some(
              (date) =>
                date.selected_schedule_type["id"] == 19 && !date.isDayDisable
            )
          )
        );
      },
      getFilteredMoviesList() {
        let temp_arr = [...this.MoviesList];
        let screen = this.selectedScreen;
        if (screen && this.MoviesList.length) {
          temp_arr = temp_arr.filter((movie) => {
            if (
              screen.videoFormats &&
              screen.videoFormats.length &&
              movie.mf_id
            ) {
              let videoFormats = screen.videoFormats.map((vf) => vf.mf_id);

              if (!videoFormats.includes(movie.mf_id)) {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          });

          temp_arr = temp_arr.filter((movie) => {
            if (
              screen.soundFormats &&
              screen.soundFormats.length &&
              movie.sound_format_id
            ) {
              let soundFormats = screen.soundFormats.map(
                (sf) => sf.sound_format_id
              );
              if (!soundFormats.includes(movie.sound_format_id)) {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          });
        }

        return temp_arr || [];
      },
      getDatesArray() {
        let startDate = moment(
          new Date(this.movieSelected.ss_start_date)
        ).format("YYYY-MM-DD");
        let endDate = moment(new Date(this.movieSelected.ss_end_date)).format(
          "YYYY-MM-DD"
        );
        var dateArray = [];
        if (moment(startDate).isValid() && moment(endDate).isValid()) {
          var currentDate = moment(startDate).format("YYYY-MM-DD");
          var stopDate = moment(endDate).format("YYYY-MM-DD");
          while (moment(currentDate).isSameOrBefore(stopDate)) {
            dateArray.push(moment(currentDate).format("DD-MM-YYYY"));
            currentDate = moment(currentDate).add(1, "days");
          }
          if (dateArray.length) {
            dateArray.unshift("Wk");
          }
        }
        return dateArray;
      },
    },
    beforeMount: function() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      // this.getAllActiveScreens();
      // this.getAllMovies();
      // this.getPosAggregatorUsers();
      this.getAllActiveCinemas(obj);
      this.getMoviesList();

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.onSelectCinema(null, CinemaObj);
      }
    },
    mounted() {
      let self = this;
      window.addEventListener("keydown", function(e) {
        if (e.shiftKey && e.keyCode === 77) {
          e.preventDefault();
          self.onAddMoviePlus(0);
        }
        if (
          e.shiftKey &&
          e.keyCode === 13 &&
          (self.cursorIndex || self.cursorIndex == 0)
        ) {
          console.log("CALLING EVENT LISTENER");
          e.preventDefault();
          self.onAddShowTimePlus(0, self.cursorIndex);
        }
      });
      this.clearingAllErr();
    },
    beforeDestroy() {
      clearInterval(this.clearErrorTime);
    },
    destroyed: function() {
      document.removeEventListener("keydown");
    },
    methods: {
      clearingAllErr() {
        // this.clearErrorTime = setInterval(() => {
        //   this.MultiScheduleArray[0]["moviesArray"].forEach(
        //     (movie, movieIndex) => {
        //       movie["showTimeArray"].forEach((show, showIndex) => {
        //         show["dateArray"].forEach((date) => {
        //           date["errType"] = "";
        //         });
        //       });
        //     }
        //   );
        // }, 15000);
      },
      onActiveUnsavedChanges(type) {
        console.log("type onActiveUnsavedChanges", type);
        this.checkForUnsavedChanges = true;
      },
      closeDialogBeforeLeave() {
        this.$bvModal.hide("unsavedConfirmation");
      },
      checkForUnsavedChangesFunc() {
        if (this.checkForUnsavedChanges) {
          this.$bvModal.show("unsavedConfirmation");
          return false;
        }
        return true;
      },
      discardChanges() {
        this.$bvModal.hide("unsavedConfirmation");
        this.checkForUnsavedChanges = false;
        this.getAllScheduleDetails();
      },
      getSupportedFormats(screen, type) {
        let text = ``;
        if (type == "mf") {
          if (
            screen.hasOwnProperty("videoFormats") &&
            screen.videoFormats.length > 0
          ) {
            let formats = screen.videoFormats.map((mf) => mf.mf_name);
            if (formats && formats.length) {
              text = formats.join(", ");
            }
          } else {
            text = `All`;
          }
        } else if (type == "sf") {
          if (
            screen.hasOwnProperty("soundFormats") &&
            screen.soundFormats.length > 0
          ) {
            let formats = screen.soundFormats.map((sf) => sf.sound_format_name);
            if (formats && formats.length) {
              text = formats.join(", ");
            }
          } else {
            text = `All`;
          }
        }
        return text;
      },
      updateCursorIndex(index) {
        this.cursorIndex = index;
      },
      collapseColorCodes() {
        this.colorCollapse = !this.colorCollapse;
      },
      checkForScheduleTypeBtn(dateArray = []) {
        let statusCount = 0;
        if (
          dateArray.some(
            (date) =>
              date.isDaySelected &&
              date.ss_id &&
              date.selected_schedule_type.id == 19 &&
              date.date !== "Wk" &&
              !date.isDayDisable
          )
        ) {
          statusCount = 1;
        } else if (
          dateArray.some(
            (date) =>
              date.isDaySelected &&
              date.ss_id &&
              date.selected_schedule_type.id == 16 &&
              date.actual_schedule_id.id == 19 &&
              date.date !== "Wk" &&
              !date.isDayDisable
          )
        ) {
          statusCount = 2;
        }
        return statusCount;
      },
      createAWeekArray() {
        let datesArray = [...this.getDatesArray];
        this.MultiScheduleArray.forEach((screen) => {
          if (screen.moviesArray.length > 0) {
            screen.moviesArray.forEach((movie) => {
              if (movie.movie_details_id) {
                movie["selectedMovie"] = this.MoviesList.find(
                  (y) => y.md_id == movie.movie_details_id
                );
              }
              movie.showTimeArray.forEach((show) => {
                show["startTime2"] = moment(
                  show["start_time"],
                  "HH:mm"
                ).isValid()
                  ? moment(show["start_time"], "HH:mm").format("HH:mm")
                  : null;
                show["ErrorArray"] = [];
                let tempArray = [];
                datesArray.forEach((date) => {
                  let checkExists = show["dateArray"].findIndex((x) =>
                    moment(
                      moment(x.date, "YYYY-MM-DD").format("YYYY-MM-DD")
                    ).isSame(moment(date, "DD-MM-YYYY").format("YYYY-MM-DD"))
                  );
                  if (checkExists > -1) {
                    let obj = {
                      ...show["dateArray"][checkExists],
                      date: moment(date, "DD-MM-YYYY").isValid()
                        ? moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                        : date,
                      day: moment(date, "DD-MM-YYYY").isValid()
                        ? moment(date, "DD-MM-YYYY").format("dddd")
                        : date,
                    };
                    tempArray.push(obj);
                  } else {
                    let obj = {
                      ...show["dateArray"][0],
                      date: moment(date, "DD-MM-YYYY").isValid()
                        ? moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                        : date,
                      day: moment(date, "DD-MM-YYYY").isValid()
                        ? moment(date, "DD-MM-YYYY").format("dddd")
                        : date,
                    };
                    tempArray.push(obj);
                  }
                });
                show["dateArray"] = [...tempArray];
              });
            });
          }
        });
        console.log("this.MultiScheduleArray", this.MultiScheduleArray);
      },
      shiftUpDown(event, type, movieIndex, showIndex) {
        console.log("shiftUpDown event, type", event, type);
        if (type == "focus") {
          this.MultiScheduleArray[0].moviesArray[movieIndex].showTimeArray[
            showIndex
          ]["timeFocus"] = "Y";
        } else {
          this.MultiScheduleArray[0].moviesArray[movieIndex].showTimeArray[
            showIndex
          ]["timeFocus"] = "N";
        }
        this.$forceUpdate();
      },
      checkValueAdded(event, type, movieIndex, showIndex, showToastMsg = true) {
        let errMsg = ``;
        let errCount = 0;
        if (type == "time") {
          if (
            !this.MultiScheduleArray[0].moviesArray[movieIndex].movie_details_id
          ) {
            errCount++;
            errMsg = `Please Select Movie`;
          }
        } else if (type == "day") {
          if (
            !this.MultiScheduleArray[0].moviesArray[movieIndex].movie_details_id
          ) {
            errCount++;
            errMsg = `Please Select Movie`;
          } else if (
            !this.MultiScheduleArray[0].moviesArray[movieIndex].showTimeArray[
              showIndex
            ].start_time
          ) {
            errCount++;
            errMsg = `Please Enter Show Time`;
          }
        }

        if (errCount > 0) {
          if (showToastMsg) {
            this.$toasted.show(errMsg);
          }
          return false;
        } else {
          return true;
        }
      },
      getAllAddonsCharges() {
        if (this.scheduleObject.cinema_id) {
          this.AddonChargesArray = [];
          let payload = {
            cinema_id: this.scheduleObject.cinema_id,
          };
          MasterService.getAllAddonsCharges(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.AddonChargesArray = data.Records.filter(
                  (z) => z.add_ons_price > 0 && z.is_addons_active == "Y"
                );
              } else {
                console.log("Error:", data.message);
              }
            })
            .catch((err) => {
              console.log("Error Catch:", err);
            });
        } else {
          console.log("Please Select Cinema: Get Addons Charges");
        }
      },
      makeAllPlannedScheduleActive() {
        this.onSubmitMultiSchedule(null, true);
      },
      onAttachRateCardDayWise(start_time, dayName, showDate) {
        let arrayMap = this.selectedScreen["screen_seat_card_mapping"];
        let screen_seat_types = this.selectedScreen["screen_seat_types"];
        let mapping_array = [];
        let final_schedule_pricing_array = [];
        let schTime = moment(start_time, "HH:mm").format("HH:mm");
        let dayCheck = `is_${dayName.toLowerCase()}`;
        let date = moment(showDate).isValid()
          ? moment(showDate).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");

        arrayMap.map((z) => {
          let rateCardStartTime = moment(
            moment(date).format("YYYY-MM-DD") +
              " " +
              moment(z.start_time, "HH:mm").format("HH:mm")
          ).format("DD-MM-YYYY HH:mm");
          let rateCardEndTime = "";
          if (
            moment(z.end_time, "HH:mm").isBefore(moment(z.start_time, "HH:mm"))
          ) {
            rateCardEndTime = moment(
              moment(date).format("YYYY-MM-DD") +
                " " +
                moment(z.end_time, "HH:mm").format("HH:mm")
            )
              .add(1, "days")
              .format("DD-MM-YYYY HH:mm");
          } else {
            rateCardEndTime = moment(
              moment(date).format("YYYY-MM-DD") +
                " " +
                moment(z.end_time, "HH:mm").format("HH:mm")
            ).format("DD-MM-YYYY HH:mm");
          }
          let startMovieTime_temp = moment(
            moment(date).format("YYYY-MM-DD") +
              " " +
              moment(schTime, "HH:mm").format("HH:mm")
          ).format("DD-MM-YYYY HH:mm");

          let cinemaStartDateTime = moment(
            moment(date).format("YYYY-MM-DD") +
              " " +
              moment(
                this.CinemasSettings.cine_operation_start_time,
                "HH:mm"
              ).format("HH:mm")
          ).format("DD-MM-YYYY HH:mm");

          if (
            moment(
              moment(startMovieTime_temp, "DD-MM-YYYY HH:mm").format(
                "YYYY-MM-DD HH:mm"
              )
            ).isSameOrAfter(
              moment(
                moment(
                  moment(date).format("YYYY-MM-DD") + " " + "00:00"
                ).format("YYYY-MM-DD 00:00")
              )
            ) &&
            moment(
              moment(startMovieTime_temp, "DD-MM-YYYY HH:mm").format(
                "YYYY-MM-DD HH:mm"
              )
            ).isBefore(
              moment(
                moment(cinemaStartDateTime, "DD-MM-YYYY HH:mm").format(
                  "YYYY-MM-DD HH:mm"
                )
              )
            )
          ) {
            startMovieTime_temp = moment(
              startMovieTime_temp,
              "DD-MM-YYYY HH:mm"
            )
              .add(1, "d")
              .format("DD-MM-YYYY HH:mm");
          }

          startMovieTime_temp = moment(
            startMovieTime_temp,
            "DD-MM-YYYY HH:mm"
          ).format("YYYY-MM-DD HH:mm");
          rateCardStartTime = moment(
            rateCardStartTime,
            "DD-MM-YYYY HH:mm"
          ).format("YYYY-MM-DD HH:mm");
          rateCardEndTime = moment(rateCardEndTime, "DD-MM-YYYY HH:mm").format(
            "YYYY-MM-DD HH:mm"
          );

          if (
            moment(startMovieTime_temp).isSame(rateCardStartTime) ||
            moment(startMovieTime_temp).isSame(rateCardEndTime) ||
            moment(startMovieTime_temp).isBetween(
              rateCardStartTime,
              rateCardEndTime
            )
          ) {
            mapping_array.push(z);
          }
        });

        if (mapping_array.length > 0 && screen_seat_types.length > 0) {
          screen_seat_types.forEach((screenType, seatTypeIndex) => {
            let screenRateCardObj = mapping_array.filter(
              (st) =>
                st.screen_seat_type_id == screenType.sst_id &&
                st[dayCheck] == "Y"
            );
            if (screenRateCardObj.length > 0) {
              let screenRateCard = screenRateCardObj[0];
              let findRateCard = this.RatecardsList.find(
                (rc) => rc.rc_g_id == screenRateCard.rate_card_id
              );
              if (findRateCard) {
                let rcObj = {
                  screen_seat_type_id: screenRateCard.screen_seat_type_id,
                  defaultRateCard:
                    findRateCard["default_rate_card"] == "Y" ? true : false,
                  rate_card_group_id: findRateCard.rc_g_id,
                  rate_card_id: findRateCard.rc_id,
                  rc_g_name: findRateCard.rc_g_name,
                  rc_name: findRateCard.rc_name,
                  rate_card_name: findRateCard.rc_name,
                  rc_total_amount: findRateCard.rc_total_amount,
                  searchRateCard: "",
                  selected_rate_card: {
                    rc_g_id: findRateCard.rc_g_id,
                    rc_g_name: findRateCard.rc_g_name,
                    rc_id: findRateCard.rc_id,
                    rc_name: findRateCard.rc_name,
                  },
                };
                final_schedule_pricing_array.push(rcObj);
              } else {
                console.log("NOT FOUND findRateCard", findRateCard);
              }
            } else {
              console.log("IN ELSE LINE 6355", screenRateCardObj);
            }
          });
        }
        if (final_schedule_pricing_array.length > 0) {
          return final_schedule_pricing_array;
        } else {
          return [];
        }
      },
      checkShowArrayLength(movieIndex) {
        let status = true;
        if (
          !this.MultiScheduleArray[0].moviesArray[
            movieIndex
          ].showTimeArray.some((show) => show.is_active == "Y")
        ) {
          status = false;
        }
        return status;
      },
      onFocusHandler() {},
      onChangeSelectedScheduleType(event) {
        console.log(event);
      },
      getAllScheduleDetails() {
        if (!this.scheduleObject.cinema_id) {
          return false;
        } else if (!this.movieSelected.ss_start_date) {
          return false;
        } else if (!this.movieSelected.ss_end_date) {
          return false;
        } else if (!this.selectedScreenId) {
          return false;
        } else {
          let loader = this.$loading.show();
          this.$bvModal.hide("unsavedConfirmation");
          let payload = {
            cinema_id: this.scheduleObject.cinema_id,
            screen_id: this.selectedScreenId,
            fromDate: moment(this.movieSelected.ss_start_date).format(
              "YYYY-MM-DD"
            ),
            toDate: moment(this.movieSelected.ss_end_date).format("YYYY-MM-DD"),
          };
          scheduleService
            .GetMultiScheduleData(payload)
            .then((response) => {
              const { data } = response;
              if (data.status && data.Records.length > 0) {
                let datesArray = [...this.getDatesArray];
                data.Records.forEach((movie, moviesIndex) => {
                  if (movie.movie_details_id) {
                    movie["selectedMovie"] = _.cloneDeep(
                      this.MoviesList.find(
                        (y) => y.md_id == movie.movie_details_id
                      )
                    );
                  }
                  movie["is_active"] = "Y";
                  movie.showTimeArray.forEach((show, showTimeIndex) => {
                    show["startTime2"] = moment(
                      show["start_time"],
                      "HH:mm"
                    ).isValid()
                      ? moment(show["start_time"], "HH:mm").format("HH:mm")
                      : null;
                    show["ErrorArray"] = [];
                    show["is_active"] = "Y";
                    let tempArray = [];
                    datesArray.forEach((date) => {
                      let checkExists = show["dateArray"].findIndex((x) =>
                        moment(
                          moment(x.date, "YYYY-MM-DD").format("YYYY-MM-DD")
                        ).isSame(
                          moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                        )
                      );
                      if (checkExists > -1) {
                        let obj = {
                          ...show["dateArray"][checkExists],
                          errType: "",
                          errColorCode: "",
                          selected_schedule_type: show["dateArray"][checkExists]
                            .ss_id
                            ? show["dateArray"][checkExists][
                                "selected_schedule_type"
                              ]
                            : this.schedule_settings[
                                "default_selected_schedule"
                              ],
                          actual_schedule_id: show["dateArray"][checkExists]
                            .ss_id
                            ? show["dateArray"][checkExists][
                                "selected_schedule_type"
                              ]
                            : this.schedule_settings[
                                "default_selected_schedule"
                              ],
                          date: moment(date, "DD-MM-YYYY").isValid()
                            ? moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                            : date,
                          day: moment(date, "DD-MM-YYYY").isValid()
                            ? moment(date, "DD-MM-YYYY").format("dddd")
                            : date,
                        };
                        tempArray.push(obj);
                      } else {
                        let obj = {
                          isDaySelected: false,
                          isDayDisable: false,
                          date: moment(date, "DD-MM-YYYY").isValid()
                            ? moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                            : date,
                          day: moment(date, "DD-MM-YYYY").isValid()
                            ? moment(date, "DD-MM-YYYY").format("dddd")
                            : date,
                          ss_id: "",
                          errType: "",
                          errColorCode: "",
                          s_interval_time_in_mins: this.CinemasSettings
                            .cine_interval_time_in_mins,
                          s_cleaning_time_in_mins: this.CinemasSettings
                            .cine_cleaning_time_in_mins,
                          s_ads_time_in_mins: this.CinemasSettings
                            .cine_setting_ads_time_in_mins,
                          selected_schedule_type: this.schedule_settings[
                            "default_selected_schedule"
                          ],
                          actual_schedule_id: this.schedule_settings[
                            "default_selected_schedule"
                          ],
                          scheduling_price: [],
                          startTime2: "",
                        };
                        tempArray.push(obj);
                      }
                    });
                    show["dateArray"] = [...tempArray];
                    setTimeout(() => {
                      this.checkWeekDays(showTimeIndex, moviesIndex);
                    }, 500);
                  });
                });

                this.MultiScheduleArray[0].moviesArray = [...data.Records];
                this.old_data_from_server = _.cloneDeep(
                  this.MultiScheduleArray
                );
                // setTimeout(() => {
                //   this.createAWeekArray();
                // }, 200);
              } else {
                this.$toasted.show(data.message || "Something Went Wrong!");
              }
            })
            .catch((err) => {
              console.log("Error:", err);
              this.$toasted.show("Something Went Wrong! line 1354");
            })
            .finally(() => {
              setTimeout(() => {
                loader.hide();
              }, 500);
            });
        }
      },
      onClickWeekDays(event, showTimeIndex, moviesIndex, day, dayIndex) {
        this.onActiveUnsavedChanges("onClickWeekDays");
        if (
          this.checkValueAdded(null, "day", moviesIndex, showTimeIndex, false)
        ) {
          let dayName = "";
          let show = this.MultiScheduleArray[0]["moviesArray"][moviesIndex][
            "showTimeArray"
          ][showTimeIndex];
          if (day.date == "Wk") {
            this.MultiScheduleArray[0]["moviesArray"][moviesIndex][
              "showTimeArray"
            ][showTimeIndex]["dateArray"].forEach((singleDate, day_index) => {
              if (singleDate.date != "Wk" && !singleDate.isDayDisable) {
                //ATTACHING RATE CARD//
                dayName = moment(singleDate.date, "YYYY-MM-DD").format("dddd");
                let sch_pricing_temp = this.onAttachRateCardDayWise(
                  show["start_time"],
                  dayName,
                  singleDate.date
                );
                //END ATTACHING RATE CARD//
                if (
                  sch_pricing_temp.length ==
                  this.selectedScreen["screen_seat_types"].length
                ) {
                  singleDate["isDaySelected"] = event;
                  singleDate["scheduling_price"] = _.cloneDeep(
                    sch_pricing_temp
                  );
                  singleDate["errType"] = "";
                  singleDate["errColorCode"] = "";
                } else {
                  this.$toasted.show(
                    `Rate Card Slot Not Available for ${dayName}`
                  );
                  singleDate["isDaySelected"] = false;
                  singleDate["errType"] = "R";
                  singleDate["errColorCode"] = "#ff00ab";
                  setTimeout(() => {
                    selectedDay["errType"] = "";
                  }, 15000);
                  // singleDate["isDayDisable"] = true;
                }
                this.checkForScheduleOverlap(
                  moviesIndex,
                  showTimeIndex,
                  day_index
                );
              }
            });
          } else {
            //ATTACHING RATE CARD//
            let selectedDay = this.MultiScheduleArray[0]["moviesArray"][
              moviesIndex
            ]["showTimeArray"][showTimeIndex]["dateArray"][dayIndex];
            if (!selectedDay.isDayDisable) {
              dayName = moment(selectedDay.date, "YYYY-MM-DD").format("dddd");
              let sch_pricing_temp = this.onAttachRateCardDayWise(
                show["start_time"],
                dayName,
                selectedDay.date
              );
              console.log("sch_pricing_temp", sch_pricing_temp);
              //END ATTACHING RATE CARD//
              if (
                sch_pricing_temp.length ==
                this.selectedScreen["screen_seat_types"].length
              ) {
                selectedDay["errType"] = "";
                selectedDay["errColorCode"] = "";
                selectedDay["isDaySelected"] = event;
                selectedDay["scheduling_price"] = _.cloneDeep(sch_pricing_temp);
              } else {
                this.$toasted.show(
                  `Rate Card Slot Not Available for ${dayName}`
                );
                selectedDay["isDaySelected"] = false;
                selectedDay["errType"] = "R";
                selectedDay["errColorCode"] = "#ff00ab";
                setTimeout(() => {
                  selectedDay["errType"] = "";
                }, 15000);
                // selectedDay["isDayDisable"] = true;
              }
              this.checkForScheduleOverlap(
                moviesIndex,
                showTimeIndex,
                dayIndex
              );
            }
          }
          setTimeout(() => {
            this.checkWeekDays(showTimeIndex, moviesIndex);
          }, 100);
        } else {
          this.$toasted.show("Please Enter Show Time");
        }
      },
      checkWeekDays(showTimeIndex, moviesIndex) {
        let AllDates = this.MultiScheduleArray[0]["moviesArray"][moviesIndex][
          "showTimeArray"
        ][showTimeIndex]["dateArray"];

        let AllDayWkIndex = this.MultiScheduleArray[0]["moviesArray"][
          moviesIndex
        ]["showTimeArray"][showTimeIndex]["dateArray"].findIndex(
          (i) => i.date == "Wk"
        );

        if (
          AllDates.length > 0 &&
          AllDates.some((z) => !z.isDaySelected && z.date != "Wk")
        ) {
          this.MultiScheduleArray[0]["moviesArray"][moviesIndex][
            "showTimeArray"
          ][showTimeIndex]["dateArray"][AllDayWkIndex]["isDaySelected"] = false;
        } else {
          this.MultiScheduleArray[0]["moviesArray"][moviesIndex][
            "showTimeArray"
          ][showTimeIndex]["dateArray"][AllDayWkIndex]["isDaySelected"] = true;
        }
      },
      filteredRateCardList(screen, screenType, tempArr = []) {
        let selectedScreen = _.cloneDeep(screen);
        let sst_id = screenType["sst_id"] || screenType["screen_seat_type_id"];
        let returnArray = [];
        let mappedRcArray = selectedScreen["selectedMappedRateCards"].filter(
          (x) => x.sst_id == sst_id
        );

        if (
          selectedScreen["selectedMappedRateCards"].length == 0 ||
          mappedRcArray.length == 0 ||
          !sst_id
        ) {
          returnArray = _.cloneDeep(tempArr);
        } else {
          returnArray = tempArr.filter((x) =>
            mappedRcArray.some((y) => y.rc_g_id == x.rc_g_id)
          );
        }
        return returnArray;
      },
      onSelectStartDate(event, type) {
        if (moment(event).isValid()) {
          this.movieSelected.ss_end_date = new Date(
            moment(event)
              .add(6, "days")
              .format("YYYY-MM-DD")
          );
          setTimeout(() => {
            this.getAllScheduleDetails();
          }, 500);
        }
      },
      onSelectSalesChannel(event, movie) {
        console.log("SELECT EVENT", event);
        event["is_changed"] = true;
        event["value"] = "Y";
        let checkIndex = -1;
        checkIndex = movie.sales_channel_changes.findIndex(
          (user) => user.user_id == event.user_id
        );
        if (checkIndex > -1) {
          movie.sales_channel_changes.splice(checkIndex, 1);
          // this.movieSelected.sales_channel_changes.push(event)
        } else {
          movie.sales_channel_changes.push(event);
        }
        console.log(
          "this.movieSelected.sales_channel_changes",
          movie.sales_channel_changes
        );
      },
      onRemoveSalesChannel(event, movie) {
        console.log("Remove EVENT", event);
        event["is_changed"] = true;
        event["value"] = "N";
        let checkIndex = -1;
        checkIndex = movie.sales_channel_changes.findIndex(
          (user) => user.user_id == event.user_id
        );
        if (checkIndex > -1) {
          movie.sales_channel_changes.splice(checkIndex, 1);
          // this.movieSelected.sales_channel_changes.push(event)
        } else {
          movie.sales_channel_changes.push(event);
        }
        console.log(
          "this.movieSelected.sales_channel_changes",
          movie.sales_channel_changes
        );
      },
      getPosAggregatorUsers: function() {
        MasterService.GetPosAggregatorUsers()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.aggregatorUsersList = data.Records;
              this.MultiScheduleArray.forEach((z) => {
                z.moviesArray.forEach((y) => {
                  y.showTimeArray.forEach((x) => {
                    x["sales_channel"] = _.cloneDeep(data.Records);
                  });
                });
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(err);
          });
      },
      _checkPreviousShowTimeFilled(movieIndex, showToast = true) {
        let errCount = 0;
        let errMsg = ``;
        let showTimeArray = _.cloneDeep(
          this.MultiScheduleArray[0].moviesArray[movieIndex].showTimeArray
        );
        showTimeArray.forEach((show) => {
          if (!show.start_time) {
            errCount++;
          } else if (!show.end_time) {
            errCount++;
          } else if (!show.dateArray.some((date) => date.isDaySelected)) {
            errCount++;
          }
        });

        console.log("errCount", errCount);

        if (errCount > 0) {
          if (showToast) {
            console.log("showTimeArray", showTimeArray);
            this.$toasted.show(`Please Fill All details of Previous Show.`);
          }
          return false;
        } else {
          return true;
        }
      },
      checkPreviousShowTimeFilled(movieIndex, showToast = true) {
        return new Promise((resolve) => {
          let errCount = 0;
          let errMsg = ``;
          let tempArr = this.MultiScheduleArray[0].moviesArray[movieIndex]
            .showTimeArray;
          let showTimeArray = _.cloneDeep(tempArr);
          showTimeArray.forEach((show) => {
            if (!show.start_time) {
              errCount++;
            } else if (!show.end_time) {
              errCount++;
            } else if (!show.dateArray.some((date) => date.isDaySelected)) {
              errCount++;
            }
          });

          console.log("errCount", errCount);

          if (errCount > 0) {
            if (showToast) {
              console.log("showTimeArray", showTimeArray);
              this.$toasted.show(`Please Fill All details of Previous Show.`);
            }
            resolve(false);
          } else {
            resolve(true);
          }
        });
      },
      resetHandler() {
        Object.assign(this.$data, getInitialData());

        let obj = this.secureStore.get("USINFO").cinema_id;
        let roleid = this.secureStore.get("USINFO").role_id;
        this.isRoleID = false;
        this.MultiScheduleArray = [
          {
            screen_id: "",
            screen_name: "Select Screen",
            selectedScreen: "",
            moviesArray: [],
          },
        ];
        this.onAddMoviePlus(0);
        this.getAllActiveCinemas(obj);
      },
      getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        var stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        console.log("dateArray :", dateArray);
        return dateArray;
      },
      checkForPastDate(date) {
        let currentDate = moment().format("YYYY-MM-DD");
        let givenDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
        if (moment(date, "DD-MM-YYYY").isValid()) {
          if (moment(givenDate).isBefore(currentDate)) return true;
        }
        return false;
      },
      onAddMoviePlus(screenIndex) {
        let MoviesObj = {
          movie_details_id: "",
          selectedMovie: "",
          lengthMinutes: "",
          is_active: "Y",
          showTimeArray: [
            {
              start_time: "",
              end_time: "",
              ErrorArray: [],
              dateArray: [],
              is_active: "Y",
            },
          ],
        };

        this.getDatesArray.forEach((date) => {
          let tempObj = {
            date: moment(date, "DD-MM-YYYY").isValid()
              ? moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
              : date,
            day: moment(date, "DD-MM-YYYY").isValid()
              ? moment(date, "DD-MM-YYYY").format("dddd")
              : date,
            isDaySelected: false,
            isDayDisable: this.checkForPastDate(date) ? true : false,
            ss_id: "",
            s_interval_time_in_mins: this.CinemasSettings
              .cine_interval_time_in_mins,
            s_cleaning_time_in_mins: this.CinemasSettings
              .cine_cleaning_time_in_mins,
            s_ads_time_in_mins: this.CinemasSettings
              .cine_setting_ads_time_in_mins,
            selected_schedule_type: this.schedule_settings[
              "default_selected_schedule"
            ],
            actual_schedule_id: this.schedule_settings[
              "default_selected_schedule"
            ],
            scheduling_price: [],
            startTime2: "",
            errType: "",
            errColorCode: "",
          };

          MoviesObj.showTimeArray[0]["dateArray"].push(tempObj);
        });

        if (this.MultiScheduleArray[screenIndex].selectedScreen != "") {
          if (
            this.MultiScheduleArray[screenIndex].selectedScreen
              .screen_seat_types.length > 0
          ) {
            this.MultiScheduleArray[
              screenIndex
            ].selectedScreen.screen_seat_types.map((y) => {
              let obj = {
                screen_seat_type_id: y.sst_id,
                sst_seat_type: y.sst_seat_type,
                rate_card_id: "",
                searchRateCard: "",
                rate_card_name: "Select Rate Card Group",
                s_interval_time_in_mins: this.CinemasSettings
                  .cine_interval_time_in_mins,
                s_cleaning_time_in_mins: this.CinemasSettings
                  .cine_cleaning_time_in_mins,
                s_ads_time_in_mins: this.CinemasSettings
                  .cine_setting_ads_time_in_mins,
                selected_schedule_type: this.schedule_settings[
                  "default_selected_schedule"
                ],
              };
              MoviesObj.showTimeArray[0]["dateArray"][0].scheduling_price.push(
                obj
              );
            });
          }
        }
        this.MultiScheduleArray[screenIndex]["moviesArray"].push(MoviesObj);
        setTimeout(() => {
          let arrayLength = this.MultiScheduleArray[screenIndex]["moviesArray"]
            .length;
          let movieEl = document.getElementById(`movie_row_${arrayLength - 1}`);
          if (movieEl) {
            movieEl.focus();
          }
        }, 300);
      },
      onRemoveMovies(screenIndex, movieIndex) {
        this.onActiveUnsavedChanges("onRemoveMovies");
        if (
          this.MultiScheduleArray[screenIndex]["moviesArray"][
            movieIndex
          ].showTimeArray.some((show) =>
            show.dateArray.some((date) => date.ss_id)
          )
        ) {
          if (
            this.MultiScheduleArray[screenIndex]["moviesArray"][
              movieIndex
            ].showTimeArray.some((show) =>
              show.dateArray.some((date) => date.isDayDisable && date.ss_id)
            )
          ) {
            this.$toasted.show("Delete not allowed for this Schedule!");
            return;
          } else {
            this.MultiScheduleArray[screenIndex]["moviesArray"][
              movieIndex
            ].showTimeArray.forEach((show, showIndex) => {
              if (show.dateArray.some((date) => date.ss_id)) {
                show.is_active = "N";

                show.dateArray.forEach((date, dayIndex) => {
                  date.isDaySelected = false;
                });
              } else {
                this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
                  "showTimeArray"
                ].splice(showIndex, 1);
              }
            });
            this.MultiScheduleArray[screenIndex]["moviesArray"][
              movieIndex
            ].is_active = "N";
          }
        } else {
          this.MultiScheduleArray[screenIndex]["moviesArray"].splice(
            movieIndex,
            1
          );
        }
      },
      onAddShowTimePlus(screenIndex, movieIndex) {
        let self = this;
        this.checkPreviousShowTimeFilled(movieIndex).then((valid) => {
          if (valid) {
            let showTimeObj = {
              start_time: "",
              end_time: "",
              ErrorArray: [],
              dateArray: [],
              is_active: "Y",
            };

            this.getDatesArray.forEach((date) => {
              let tempObj = {
                date: moment(date, "DD-MM-YYYY").isValid()
                  ? moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                  : date,
                day: moment(date, "DD-MM-YYYY").isValid()
                  ? moment(date, "DD-MM-YYYY").format("dddd")
                  : date,
                isDaySelected: false,
                errType: "",
                errColorCode: "",
                isDayDisable: this.checkForPastDate(date) ? true : false,
                ss_id: "",
                s_interval_time_in_mins: this.CinemasSettings
                  .cine_interval_time_in_mins,
                s_cleaning_time_in_mins: this.CinemasSettings
                  .cine_cleaning_time_in_mins,
                s_ads_time_in_mins: this.CinemasSettings
                  .cine_setting_ads_time_in_mins,
                selected_schedule_type: this.schedule_settings[
                  "default_selected_schedule"
                ],
                actual_schedule_id: this.schedule_settings[
                  "default_selected_schedule"
                ],
                scheduling_price: [],
                startTime2: "",
              };

              this.MultiScheduleArray[
                screenIndex
              ].selectedScreen.screen_seat_types.map((y) => {
                let obj = {
                  screen_seat_type_id: y.sst_id,
                  sst_seat_type: y.sst_seat_type,
                  rate_card_id: "",
                  searchRateCard: "",
                  selected_rate_card: undefined,
                  rate_card_name: "Select Rate Card Group",
                };
                tempObj.scheduling_price.push(obj);
              });

              showTimeObj["dateArray"].push(tempObj);
            });

            this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
              "showTimeArray"
            ].push(showTimeObj);
            let showIndex =
              this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
                "showTimeArray"
              ].length - 1;
            setTimeout(() => {
              let timeEl = document.getElementById(
                `showtimeBox${"M_" + movieIndex + "S_" + showIndex}`
              );
              if (timeEl) {
                let inputNodes = timeEl.getElementsByTagName("INPUT");
                if (inputNodes && inputNodes.length > 0) {
                  inputNodes[0].focus();
                }
              }
            }, 200);
          }
        });
      },
      onChangeShowStatusToSchedule(
        screenIndex,
        movieIndex,
        showTimeIndex,
        type = 19
      ) {
        this.MultiScheduleArray[screenIndex].moviesArray[
          movieIndex
        ].showTimeArray[showTimeIndex].dateArray.forEach((date, dateIndex) => {
          if (!date.isDayDisable && date.isDaySelected) {
            date.selected_schedule_type = this.scheduleTypeArray.find(
              (x) => x.id == type
            );
          }
        });
        this.onActiveUnsavedChanges("onChangeShowStatusToSchedule");
        console.log(
          "this.MultiScheduleArray DATE ARRAY",
          this.MultiScheduleArray[screenIndex].moviesArray[movieIndex]
            .showTimeArray[showTimeIndex]
        );
      },
      onRemoveShowTime(screenIndex, movieIndex, showTimeIndex) {
        this.onActiveUnsavedChanges("onRemoveShowTime");
        let show = this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].showTimeArray[showTimeIndex];
        if (show.dateArray.some((date) => date.isDayDisable && date.ss_id)) {
          this.$toasted.show("Delete not allowed for this Schedule!");
        } else if (show.dateArray.some((date) => date.ss_id)) {
          show.is_active = "N";
          show.dateArray.forEach((date, dayIndex) => {
            date.isDaySelected = false;
          });
        } else {
          this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
            "showTimeArray"
          ].splice(showTimeIndex, 1);
        }
      },
      onSearchCinema(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.CinemasList = this.CinemasListCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.CinemasList = this.CinemasListCopy;
        }
      },
      scrolfun() {
        console.log("scrolling");
        this.topValue = event.srcElement.scrollTop;
      },
      clear_ss_start_date: function() {
        this.movieSelected.ss_start_date = null;
        this.movieSelected.ss_end_date = null;
      },
      onChangeShowStartTime: function(
        event,
        screenIndex,
        movieIndex,
        showTimeIndex
      ) {
        this.onActiveUnsavedChanges("onChangeShowStartTime");
        let old_start_time = this.MultiScheduleArray[screenIndex][
          "moviesArray"
        ][movieIndex]["showTimeArray"][showTimeIndex]["start_time"];

        let old_end_time = this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ]["showTimeArray"][showTimeIndex]["end_time"];

        if (event.displayTime && moment(event.displayTime, "HH:mm").isValid()) {
          event = new Date(
            moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
          );

          if (event === null) {
            this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
              "showTimeArray"
            ][showTimeIndex]["start_time"] = "";
            this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
              "showTimeArray"
            ][showTimeIndex]["end_time"] = "";
            return;
          }

          this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
            "showTimeArray"
          ][showTimeIndex]["start_time"] = moment(event).format("HH:mm");
          this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
            "showTimeArray"
          ][showTimeIndex]["end_time"] = moment(event)
            .add(this.getTotalMovieTime(screenIndex, movieIndex), "m")
            .format("HH:mm");

          let errCount = 0;
          let errMsg = ``;
          let no_overlap = true;
          let sch_pricing_temp = [];
          let tempMultiSchedule = _.cloneDeep(
            this.MultiScheduleArray[0].moviesArray
          );

          if (
            moment(old_start_time, "HH:mm").isValid() &&
            moment(old_end_time, "HH:mm").isValid()
          ) {
            tempMultiSchedule[movieIndex].showTimeArray[
              showTimeIndex
            ].dateArray.forEach((date, dayIndex) => {
              if (date.date != "Wk" && date.isDaySelected) {
                let dayName = moment(date.date, "YYYY-MM-DD").format("dddd");
                sch_pricing_temp = this.onAttachRateCardDayWise(
                  moment(event).format("HH:mm"),
                  dayName,
                  date.date
                );

                no_overlap = this.checkForScheduleOverlap(
                  movieIndex,
                  showTimeIndex,
                  dayIndex,
                  true
                );

                if (
                  sch_pricing_temp.length !=
                  this.selectedScreen["screen_seat_types"].length
                ) {
                  errCount++;
                  errMsg = `Rate Card Slot Not Available for ${dayName}`;
                } else {
                  date["scheduling_price"] = _.cloneDeep(sch_pricing_temp);
                }

                if (!no_overlap) {
                  errCount++;
                }
              }
            });

            if (errMsg) {
              this.$toasted.show(errMsg);
            }

            if (errCount > 0) {
              this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
                "showTimeArray"
              ][showTimeIndex]["start_time"] = old_start_time;

              this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
                "showTimeArray"
              ][showTimeIndex]["end_time"] = old_end_time;

              this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
                "showTimeArray"
              ][showTimeIndex]["startTime2"] = moment(
                old_start_time,
                "HH:mm"
              ).isValid()
                ? moment(old_start_time, "HH:mm").format("HH:mm")
                : null;
            } else {
              this.MultiScheduleArray[0].moviesArray = _.cloneDeep(
                tempMultiSchedule
              );
            }
          }
        } else {
          console.log("Invalid Time");
        }
      },
      getScreenPositionCalc: function(start_time) {
        let cinema_start_time = this.CinemasSettings.cine_operation_start_time;
        let cinema_ampm = cinema_start_time.split(" ")[1];
        let cinema_minutes = parseInt(cinema_start_time.split(":")[1]);
        let cinema_hours = parseInt(cinema_start_time.split(":")[0]);

        let start = 0;
        let cinema_start = 0;
        let hours = 0;
        let minutes = 0;
        let totalMinutes = 0;
        let ampm = start_time.split(" ")[1];
        minutes = parseInt(start_time.split(":")[1]);
        hours = parseInt(start_time.split(":")[0]);
        if (ampm == "PM" && hours === 12) {
          hours = hours;
        } else if (ampm == "PM") {
          hours = hours + 12;
        }

        if (ampm == "AM" && hours === 12) {
          totalMinutes = minutes;
          cinema_start = parseInt(totalMinutes * 30) / 10;
          return cinema_start;
        } else {
          totalMinutes = parseInt(hours * 60) + minutes;
          cinema_start = parseInt(totalMinutes * 30) / 10;
          return cinema_start;
        }

        totalMinutes = parseInt(hours * 60) + minutes;
        cinema_start = parseInt(totalMinutes * 30) / 10;
        return cinema_start;
      },
      // Cinema List
      getAllActiveCinemas: function(cine_id) {
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.CinemasList = data.Records;
              this.CinemasListCopy = data.Records;
              this.CinemasList.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.selected.cinema = x.cine_name;
                  let cinema = {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  };
                  this.onSelectCinema(event, cinema);
                }
              });
            } else {
              // Show Error message
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveCinemas :", error);
          });
      },
      getCinemaSetting: function(cinema_id) {
        scheduleService
          .GetCinemaSetting({ cinema_id })
          .then((response) => {
            const { data } = response;
            console.log("data.timeZone :", data.timeZone);
            if (data && data.status && data.Records.length > 0) {
              this.CinemasSettings = {
                ...this.CinemasSettings,
                ...data.Records[0],
              };
              if (
                data.timeZone &&
                data.timeZone.tz_name &&
                data.timeZone.tz_name.length > 0
              ) {
                this.timeZone = {
                  ...this.timeZone,
                  ...data.timeZone,
                };
                // this.getAllActiveMovies();
                this.attachMovieAddtionalTimmings();
              } else {
                this.$toasted.show(
                  "Please Add default Timezone in Cinema Settings"
                );
                this.$refs["test"].hide();
              }
              let startString = "";
              if (
                this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                  "AM" ||
                this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                  "PM"
              ) {
                startString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).format("YYYY-MM-DD h:mm A");
              } else {
                startString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).format("YYYY-MM-DD H:mm");
              }

              let endString = "";
              if (
                this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                  "AM" ||
                this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                  "PM"
              ) {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).format("YYYY-MM-DD h:mm A");
              } else if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).isAfter(
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.CinemasSettings.cine_operation_end_time
                  )
                )
              ) {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
                  .add(1, "d")
                  .format("YYYY-MM-DD H:mm");
              } else if (
                this.CinemasSettings.cine_operation_end_time.split(":")[0] < 12
              ) {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
                  .add(1, "d")
                  .format("YYYY-MM-DD H:mm");
              } else {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).format("YYYY-MM-DD H:mm");
              }
              this.intervalsArray = intervals(startString, endString);
              function intervals(startString, endString) {
                var start = moment(startString, "YYYY-MM-DD hh:mm a");
                var end = moment(endString, "YYYY-MM-DD hh:mm a");

                start.minutes(Math.ceil(start.minutes() / 15) * 15);

                var result = [];

                var current = moment(start);
                end = moment(end);
                end.add(4 * 60, "minutes");
                console.log("current :", current);
                while (current <= end) {
                  result.push(current.format("HH:mm"));
                  current.add(60, "minutes");
                }

                return result;
              }
            } else {
              this.$toasted.show(
                "No Cinema Settings Found for selected cinema"
              );
              this.$refs["test"].hide();
            }
          })
          .catch((error) => {
            console.log("Catch Error on getCinemaSetting :", error);
          });
      },
      attachMovieAddtionalTimmings() {
        if (this.MoviesList.length > 0) {
          this.MoviesList.forEach((movie) => {
            movie.lengthMinutes =
              movie.mrrdr_runtime +
              this.CinemasSettings.cine_cleaning_time_in_mins +
              this.CinemasSettings.cine_setting_ads_time_in_mins +
              this.CinemasSettings.cine_interval_time_in_mins;
            movie.length = (movie.lengthMinutes * 30) / 10;
            movie.rateCard = [];
            movie.md_sales_channel = movie.md_sales_channel;
            movie.scheduleShowPrice = [];
            movie.md_id = movie.md_id;
            movie.interval_time_in_mins = this.CinemasSettings.cine_interval_time_in_mins;
            movie.cleaning_time_in_mins = this.CinemasSettings.cine_cleaning_time_in_mins;
            movie.ads_time_in_mins = this.CinemasSettings.cine_setting_ads_time_in_mins;
            movie.movie_name =
              movie.sound_format_name &&
              String(movie.sound_format_name).length > 0
                ? movie.movie_title +
                  (movie.mf_name ? " " + movie.mf_name + " -" : " -") +
                  [
                    movie.lang_iso_2,
                    movie.sub_lang_1_iso_2,
                    movie.sub_lang_2_iso_2,
                  ]
                    .filter(Boolean)
                    .join("/")
                    .toUpperCase() +
                  " (" +
                  movie.sound_format_name +
                  ")"
                : movie.movie_title +
                  (movie.mf_name ? " " + movie.mf_name + " -" : " -") +
                  [
                    movie.lang_iso_2,
                    movie.sub_lang_1_iso_2,
                    movie.sub_lang_2_iso_2,
                  ]
                    .filter(Boolean)
                    .join("/")
                    .toUpperCase();
          });
        }
      },
      getRatecardsList: function(cinema_id) {
        scheduleService
          .GetRatecardGroupByCinemaId({ cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.RatecardsList = data.Records;
              this.RatecardsListCopy = data.Records;
            } else {
              this.RatecardsList = [];
              this.RatecardsListCopy = [];
              // Show Message Here:
              this.$toasted.show("No Rate Cards Found for selected cinema");
              this.$refs["test"].hide();
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getCinemaSetting :", error);
          });
      },
      onAsyncSearchMovies: _.debounce(function(query) {
        if (query) {
          this.searchValue = query;
          this.getMoviesList();
        }
      }, 1 * 1000),
      getAllActiveMovies: function() {
        this.MoviesList = [];
        this.isSearchLoading = true;
        scheduleService
          .GetMovies({ schedule: this.searchValue })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.MovieListResult.length > 0) {
              this.MoviesList = data.MovieListResult.filter(
                (movie, movieIndex) => {
                  if (movie.movie_is_active == "Y") {
                    movie.lengthMinutes =
                      movie.mrrdr_runtime +
                      this.CinemasSettings.cine_cleaning_time_in_mins +
                      this.CinemasSettings.cine_setting_ads_time_in_mins +
                      this.CinemasSettings.cine_interval_time_in_mins;
                    movie.length = (movie.lengthMinutes * 30) / 10;
                    movie.rateCard = [];
                    movie.md_sales_channel = movie.md_sales_channel;
                    movie.scheduleShowPrice = [];
                    movie.md_id = movie.md_id;
                    movie.interval_time_in_mins = this.CinemasSettings.cine_interval_time_in_mins;
                    movie.cleaning_time_in_mins = this.CinemasSettings.cine_cleaning_time_in_mins;
                    movie.ads_time_in_mins = this.CinemasSettings.cine_setting_ads_time_in_mins;
                    movie.movie_name =
                      movie.sound_format_name &&
                      String(movie.sound_format_name).length > 0
                        ? movie.movie_title +
                          (movie.mf_name ? " " + movie.mf_name + " -" : " -") +
                          [
                            movie.lang_iso_2,
                            movie.sub_lang_1_iso_2,
                            movie.sub_lang_2_iso_2,
                          ]
                            .filter(Boolean)
                            .join("/")
                            .toUpperCase() +
                          " (" +
                          movie.sound_format_name +
                          ")"
                        : movie.movie_title +
                          (movie.mf_name ? " " + movie.mf_name + " -" : " -") +
                          [
                            movie.lang_iso_2,
                            movie.sub_lang_1_iso_2,
                            movie.sub_lang_2_iso_2,
                          ]
                            .filter(Boolean)
                            .join("/")
                            .toUpperCase();
                    return movie;
                  }
                }
              );
              this.showScheduleCard = true;
              // this.lists.movies = movieList;
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getAllActiveMovies :", error);
          })
          .finally(() => {
            this.isSearchLoading = false;
          });
      },
      getMoviesList() {
        this.MoviesList = [];
        this.isSearchLoading = true;
        let loader = this.$loading.show();
        scheduleService
          .GetMovies({ schedule: this.searchValue })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.MovieListResult.length > 0) {
              this.MoviesList = data.MovieListResult.filter(
                (movie) => movie.movie_is_active == "Y"
              );
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            this.isSearchLoading = false;
            setTimeout(() => {
              loader.hide();
            }, 1000);
          });
      },
      getAllActiveScreens: function(cinema_id) {
        console.log("cinema_id :", cinema_id);
        this.ScreenList = [];
        let payload = {
          cinema_id: cinema_id,
        };

        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // this.lists.screens = data.Records;
              this.ScreenList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              this.ScreenListCopy = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              this.selectedMoviesInScreens = [];
              this.ScreenList.map((x) => {
                this.selectedMoviesInScreens.push({
                  ...x,
                  movies: [],
                });
              });
              // initial sreen value if null
              // this.MultiScheduleArray[0]["selectedScreen"] = this.ScreenList[0];
              // this.MultiScheduleArray[0][
              //   "screen_id"
              // ] = this.ScreenList[0].screen_id;
              this.onSelectScreen(null, this.ScreenList[0], 0, 0);
              // initial sreen value if null

              console.log(this.ScreenList, this.selectedMoviesInScreens);
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveScreens :", error);
          });
      },
      getSeatTypesListByScreenId: function(screen_id) {
        scheduleService
          .GetSeatTypesByScreenId({ screen_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getSeatTypesListByScreenId :", error);
          });
      },
      onChangeRateCardMulti: function(
        ratecard,
        seat,
        screenIndex,
        movieIndex,
        showTimeIndex,
        SeatTypeIndex
      ) {
        // console.log("event, seat, SeatTypeIndex :", event, seat, SeatTypeIndex);
        // this.selectedRateCardObject.rate_card_id = event.target.value;
        console.log("ratecard :", ratecard);
        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ][showTimeIndex]["scheduling_price"][SeatTypeIndex]["rate_card_name"] =
          ratecard.rc_g_name;
        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ][showTimeIndex]["scheduling_price"][SeatTypeIndex][
          "rate_card_group_id"
        ] = ratecard.rc_g_id;
        this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex][
          "showTimeArray"
        ][showTimeIndex]["scheduling_price"][SeatTypeIndex]["rate_card_id"] =
          ratecard.rc_id;
        // this.selectedRateCardObject.rate_card_id = ratecard.rc_id;
        // this.selectedRateCardObject.rate_card_name = ratecard.rate_card_name;
        // this.selectedRateCardObject.screen_seat_type_id = seat.sst_id;

        // this.selectedRateCardObject.SeatTypeIndex = SeatTypeIndex;
        // this.movieSelected.scheduleShowPrice.map((x) => {
        //   x.searchRateCard = "";
        // });
        // this.RatecardsList = this.RatecardsListCopy;

        // let obj = this.movieSelected.scheduleShowPrice[SeatTypeIndex];

        // let _Obj = {
        //   ...obj,
        //   rate_card_id: ratecard.rc_id,
        //   searchRateCard: "",
        //   rate_card_name: ratecard.rate_card_name,
        //   screen_seat_type_id: seat.sst_id,
        // };
        // Vue.set(this.movieSelected.scheduleShowPrice, SeatTypeIndex, _Obj);
        this.$forceUpdate();
      },
      onSelectCinema: function(event, cinema) {
        this.selected.cinemaObject = cinema;
        this.selected.cinema = cinema.cine_name;
        this.scheduleObject.cinema_id = cinema.cine_id;
        this.getAllActiveScreens(cinema.cine_id);
        this.getCinemaSetting(cinema.cine_id);
        this.getRatecardsList(cinema.cine_id);
        this.clearMultiSchedule();
        this.getAllScheduleDetails();
        this.getAllAddonsCharges();
        this.submitted = false;
      },
      onSelectScreen: function(event, screen, screenIndex, screenMainIndex) {
        let findIndexScreen = this.MultiScheduleArray.findIndex((x) => {
          return x.screen_id == screen.screen_id;
        });
        if (this.checkForUnsavedChangesFunc()) {
          if (screen.totalSeatLayout > 0) {
            this.selectedScreenId = screen.screen_id;
            this.selectedScreen = screen;
            this.getAllScheduleDetails();
            this.MultiScheduleArray[screenMainIndex]["screen_name"] =
              screen.screen_name;
            this.MultiScheduleArray[screenMainIndex]["screen_id"] =
              screen.screen_id;
            this.MultiScheduleArray[screenMainIndex]["selectedScreen"] = screen;
            if (screen.screen_seat_types.length > 0) {
              let schedulingArray = [];
              screen.screen_seat_types.map((y) => {
                let obj = {
                  screen_seat_type_id: y.sst_id,
                  sst_seat_type: y.sst_seat_type,
                  rate_card_id: "",
                  searchRateCard: "",
                  rate_card_name: "Select Rate Card Group",
                };
                schedulingArray.push(obj);
              });

              this.MultiScheduleArray[screenMainIndex]["moviesArray"].map(
                (x) => {
                  x.showTimeArray.map((z) => {
                    z["sales_channel"] = _.cloneDeep(this.aggregatorUsersList);
                    z["sales_channel_changes"] = [];
                    z["scheduling_price"] = schedulingArray;
                  });
                }
              );
            } else {
              this.MultiScheduleArray[screenMainIndex]["moviesArray"].map(
                (x) => {
                  x.showTimeArray.map((z) => {
                    z["sales_channel"] = _.cloneDeep(this.aggregatorUsersList);
                    z["sales_channel_changes"] = [];
                    z["scheduling_price"] = [];
                  });
                }
              );
            }
          } else if (screen.totalSeatLayout == 0) {
            this.$toasted.show(screen.screen_name + " has no seat layout");
          } else {
            this.$toasted.show(screen.screen_name + " Screen Already Exist");
          }
        }
      },
      clearMultiSchedule() {
        this.MultiScheduleArray = [
          {
            screen_id: null,
            screen_name: "",
            selectedScreen: "",
            moviesArray: [],
          },
        ];
        this.onAddMoviePlus(0);
      },
      onSelectMovie: function(movie, movieIndex, screenIndex) {
        console.log(movie, movieIndex, screenIndex);
        this.onActiveUnsavedChanges("onSelectMovie");
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].movie_details_id = movie.md_id;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].cleaning_time_in_mins = movie.cleaning_time_in_mins;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].ads_time_in_mins = movie.ads_time_in_mins;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].interval_time_in_mins = movie.interval_time_in_mins;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].lengthMinutes = movie.lengthMinutes;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].addons_array = this.attachAddons(movie);

        // let movieIndex = this.MoviesList.findIndex((x) => {
        //   return movie.md_id == x.md_id;
        // });

        // this.selectedMovie == movie;
        // this.selectedMovieIndex = movieIndex + Math.floor(Math.random() * 10);
        // this.movieSelected = {
        //   ...this.movieSelected,
        //   ...movie,
        // };
        // this.selectedScreenSeatTypes = this.selectedScreen.screen_seat_types;

        // let seat_type_length = this.selectedMoviesInScreens[
        //   this.selectedScreenIndex
        // ].screen_seat_types.length;

        // let scheduleShowPriceObj = {
        //   rate_card_id: null,
        //   searchRateCard: "",
        //   rate_card_name: "Select Rate Card Group",
        //   schedule_show_id: null,
        //   screen_seat_type_id: null,
        //   p_start_date_time: null,
        //   p_end_date_time: null,
        //   p_is_active: "Y",
        // };

        // let scheduleShowPriceArray = [];

        // for (var i = 0; i < seat_type_length; i++) {
        //   scheduleShowPriceArray.push(scheduleShowPriceObj);
        // }
        // if (String(this.selectedScreenIndex).length > 0) {
        //   Object.assign(this.movieSelected, {
        //     scheduleShowPrice: scheduleShowPriceArray,
        //   });
        // }

        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].formatError = false;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].soundFormatError = false;
        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].licenseDateError = false;

        let temp_sales_channel = [];
        let temp_sales_channel_changes = [];

        if (
          movie.hasOwnProperty("md_sales_channel") &&
          movie.md_sales_channel
        ) {
          this.aggregatorUsersList.map((u) => {
            if (!movie.md_sales_channel.some((el) => el.user_id == u.user_id)) {
              let obj = {
                ...u,
                is_changed: true,
                value: "N",
              };
              temp_sales_channel_changes.push(obj);
            } else {
              temp_sales_channel.push(u);
            }
          });
        } else {
          temp_sales_channel = _.cloneDeep(this.aggregatorUsersList);
          temp_sales_channel_changes = [];
        }

        this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ].showTimeArray.forEach((st) => {
          st["sales_channel"] = _.cloneDeep(temp_sales_channel);
          st["sales_channel_changes"] = _.cloneDeep(temp_sales_channel_changes);
        });

        setTimeout(() => {
          let timeEl = document.getElementById(
            `showtimeBox${"M_" + movieIndex + "S_" + 0}`
          );
          if (timeEl) {
            let inputNodes = timeEl.getElementsByTagName("INPUT");
            if (inputNodes && inputNodes.length > 0) {
              inputNodes[0].focus();
            }
          }
        }, 200);

        this.$forceUpdate();
      },
      selectCinema: function(cinema) {
        this.lists.cinemas.selectedCinema = cinema;
      },
      changeCinema: function(params) {
        this.initialSelectedScreen = params;
      },
      getTotalMovieTime: function(screenIndex, movieIndex) {
        let movieObj = this.MultiScheduleArray[screenIndex]["moviesArray"][
          movieIndex
        ];
        let movierunTime = parseInt(movieObj.selectedMovie.mrrdr_runtime) || 0;
        let interval = parseInt(movieObj.interval_time_in_mins) || 0;
        let cleaningTime = parseInt(movieObj.cleaning_time_in_mins) || 0;
        let advertisementTime = parseInt(movieObj.ads_time_in_mins) || 0;

        return parseInt(
          movierunTime + interval + cleaningTime + advertisementTime
        );
      },
      checkConflictsBeforeSubmit: function() {
        let doesConflictsExist = false;

        for (
          let screenIndex = 0;
          screenIndex < this.MultiScheduleArray.length;
          screenIndex++
        ) {
          for (
            let movieIndex = 0;
            movieIndex <
            this.MultiScheduleArray[screenIndex]["moviesArray"].length;
            movieIndex++
          ) {
            for (
              let showtimeIndex = 0;
              showtimeIndex <
              this.MultiScheduleArray[screenIndex]["moviesArray"][movieIndex]
                .showTimeArray.length;
              showtimeIndex++
            ) {
              let showtime = this.MultiScheduleArray[screenIndex][
                "moviesArray"
              ][movieIndex].showTimeArray[showtimeIndex];
              if (showtime.doesConflict === true) {
                doesConflictsExist = true;
                break;
              }
            }
          }
        }

        return doesConflictsExist;
      },
      checkForScheduleOverlap(
        movieIndex,
        showTimeIndex,
        dayIndex,
        onlyCheck = false
      ) {
        let errCount = 0;
        let errArray = [];
        let start_date_time = moment(
          `${moment(
            this.MultiScheduleArray[0].moviesArray[movieIndex].showTimeArray[
              showTimeIndex
            ].dateArray[dayIndex].date
          ).format("YYYY-MM-DD")} ${moment(
            this.MultiScheduleArray[0].moviesArray[movieIndex].showTimeArray[
              showTimeIndex
            ].start_time,
            "HH:mm"
          ).format("HH:mm")}`
        ).format("YYYY-MM-DD HH:mm");

        let end_date_time = moment(
          `${moment(
            this.MultiScheduleArray[0].moviesArray[movieIndex].showTimeArray[
              showTimeIndex
            ].dateArray[dayIndex].date
          ).format("YYYY-MM-DD")} ${moment(
            this.MultiScheduleArray[0].moviesArray[movieIndex].showTimeArray[
              showTimeIndex
            ].end_time,
            "HH:mm"
          ).format("HH:mm")}`
        ).format("YYYY-MM-DD HH:mm");

        if (moment(end_date_time).isBefore(start_date_time)) {
          end_date_time = moment(end_date_time)
            .add(1, "d")
            .format("YYYY-MM-DD HH:mm");
        }

        this.MultiScheduleArray[0].moviesArray.forEach((movie, movie_index) => {
          movie.showTimeArray.forEach((show, show_index) => {
            show.dateArray.forEach((date, date_index) => {
              if (
                `M-${movie_index}S-${show_index}D-${date_index}` !=
                  `M-${movieIndex}S-${showTimeIndex}D-${dayIndex}` &&
                date.date != "Wk" &&
                date.isDaySelected &&
                moment(moment(date.date).format("YYYY-MM-DD")).isSame(
                  moment(start_date_time).format("YYYY-MM-DD")
                )
              ) {
                let movie_show_start_date_time = moment(
                  `${moment(date.date).format("YYYY-MM-DD")} ${moment(
                    show.start_time,
                    "HH:mm"
                  ).format("HH:mm")}`
                ).format("YYYY-MM-DD HH:mm");

                let movie_show_end_date_time = moment(
                  `${moment(date.date).format("YYYY-MM-DD")} ${moment(
                    show.end_time,
                    "HH:mm"
                  ).format("HH:mm")}`
                ).format("YYYY-MM-DD HH:mm");

                if (
                  moment(movie_show_end_date_time).isBefore(
                    movie_show_start_date_time
                  )
                ) {
                  movie_show_end_date_time = moment(movie_show_end_date_time)
                    .add(1, "d")
                    .format("YYYY-MM-DD HH:mm");
                }

                // console.table({
                //   start_date_time_between: moment(start_date_time).isBetween(
                //     movie_show_start_date_time,
                //     movie_show_end_date_time
                //   ),
                //   end_date_time_between: moment(end_date_time).isBetween(
                //     movie_show_start_date_time,
                //     movie_show_end_date_time
                //   ),
                //   start_date_time_same_start: moment(start_date_time).isSame(
                //     movie_show_start_date_time
                //   ),
                //   end_date_time_same_start: moment(end_date_time).isSame(
                //     movie_show_start_date_time
                //   ),
                //   start_date_time_same_end: moment(start_date_time).isSame(
                //     movie_show_end_date_time
                //   ),
                //   end_date_time_same_end: moment(end_date_time).isSame(
                //     movie_show_end_date_time
                //   ),
                //   start_date_time: start_date_time,
                //   end_date_time: end_date_time,
                //   movie_show_start_date_time: movie_show_start_date_time,
                //   movie_show_end_date_time: movie_show_end_date_time,
                //   onlyCheck: onlyCheck,
                // });

                if (
                  moment(start_date_time).isBetween(
                    movie_show_start_date_time,
                    movie_show_end_date_time
                  ) ||
                  moment(end_date_time).isBetween(
                    movie_show_start_date_time,
                    movie_show_end_date_time
                  ) ||
                  moment(start_date_time).isSame(movie_show_start_date_time) ||
                  moment(end_date_time).isSame(movie_show_start_date_time) ||
                  moment(start_date_time).isSame(movie_show_end_date_time) ||
                  moment(end_date_time).isSame(movie_show_end_date_time)
                ) {
                  errCount++;
                  if (!onlyCheck) {
                    this.MultiScheduleArray[0].moviesArray[
                      movieIndex
                    ].showTimeArray[showTimeIndex].dateArray[
                      dayIndex
                    ].isDaySelected = false;
                  }

                  this.MultiScheduleArray[0].moviesArray[
                    movieIndex
                  ].showTimeArray[showTimeIndex].dateArray[dayIndex][
                    "errType"
                  ] = "O";
                  this.MultiScheduleArray[0].moviesArray[
                    movieIndex
                  ].showTimeArray[showTimeIndex].dateArray[dayIndex][
                    "errColorCode"
                  ] = "#891414";

                  setTimeout(() => {
                    this.MultiScheduleArray[0].moviesArray[
                      movieIndex
                    ].showTimeArray[showTimeIndex].dateArray[dayIndex][
                      "errType"
                    ] = "";
                  }, 15000);

                  let errObj = {
                    type: "Overlap",
                    start_time: show.start_time,
                    end_time: show.end_time,
                    show_index: show_index,
                    movie_index: movie_index,
                    date_index: date_index,
                    error_msg: `Show Overlap with Movie: ${
                      movie.selectedMovie["movie_name"]
                    } Show: ${moment(date.date).format("DD.MMM")} ${moment(
                      show.start_time,
                      "HH:mm"
                    ).format("HH:mm")}`,
                  };
                  this.$toasted.show(errObj["error_msg"]);
                }
              }
            });
          });
        });

        if (errCount > 0) {
          return false;
        } else {
          return true;
        }
      },
      attachAddons(screenMovie) {
        let tempAddonsArray = [];
        if (screenMovie.mf_id) {
          let tempArray = [];
          tempArray = this.AddonChargesArray.filter(
            (z) =>
              z.type_id == 1 &&
              z.main_id == screenMovie.mf_id &&
              z.add_ons_price > 0 &&
              z.is_compulsory_add_ons == "Y"
          );
          tempAddonsArray.push(...tempArray);
        }
        if (screenMovie.movie_experience_id) {
          let tempArray = [];
          tempArray = this.AddonChargesArray.filter(
            (z) =>
              z.type_id == 2 &&
              z.main_id == screenMovie.movie_experience_id &&
              z.add_ons_price > 0 &&
              z.is_compulsory_add_ons == "Y"
          );
          tempAddonsArray.push(...tempArray);
        }
        if (screenMovie.sound_format_id) {
          let tempArray = [];
          tempArray = this.AddonChargesArray.filter(
            (z) =>
              z.type_id == 3 &&
              z.main_id == screenMovie.sound_format_id &&
              z.add_ons_price > 0 &&
              z.is_compulsory_add_ons == "Y"
          );
          tempAddonsArray.push(...tempArray);
        }
        if (screenMovie.movie_resolution_id) {
          let tempArray = [];
          tempArray = this.AddonChargesArray.filter(
            (z) =>
              z.type_id == 4 &&
              z.main_id == screenMovie.movie_resolution_id &&
              z.add_ons_price > 0 &&
              z.is_compulsory_add_ons == "Y"
          );
          tempAddonsArray.push(...tempArray);
        }
        if (screenMovie.aspect_ratio_id) {
          let tempArray = [];
          tempArray = this.AddonChargesArray.filter(
            (z) =>
              z.type_id == 5 &&
              z.main_id == screenMovie.aspect_ratio_id &&
              z.add_ons_price > 0 &&
              z.is_compulsory_add_ons == "Y"
          );
          tempAddonsArray.push(...tempArray);
        }
        let tempArray = [];
        tempArray = this.AddonChargesArray.filter(
          (z) =>
            z.type_id == 0 &&
            z.add_ons_price > 0 &&
            z.is_compulsory_add_ons == "Y"
        );
        tempAddonsArray.push(...tempArray);

        return tempAddonsArray;
      },
      onSubmitMultiSchedule(event, changeStatus = false) {
        let tempArray = _.cloneDeep(this.MultiScheduleArray[0].moviesArray);

        let filteredMultiSchedule = tempArray
          .map((movie) => {
            let tempArr = [];
            tempArr = movie.showTimeArray.filter((show) =>
              show.dateArray.some((date) => date.isDaySelected)
            );
            movie["showTimeArray"] = _.cloneDeep(tempArr);
            return movie;
          })
          .filter((movie) => movie.showTimeArray.length > 0);

        filteredMultiSchedule.forEach((movie) => {
          movie.showTimeArray.forEach((show) => {
            let tempArr = show.dateArray.filter((date) => {
              if (date.date == "Wk") return false;
              if (changeStatus && !date.isDayDisable) {
                date["selected_schedule_type"] = {
                  type: "Scheduled",
                  id: 16,
                };
              }
              return date;
            });
            show.dateArray = [...tempArr];
          });
        });
        if (!this.scheduleObject.cinema_id) {
          return this.$toasted.show("Please Select Cinema");
        } else if (!this.movieSelected.ss_start_date) {
          return this.$toasted.show("Please Select Dates");
        } else if (!this.movieSelected.ss_end_date) {
          return this.$toasted.show("Please Select Dates");
        } else if (!this.selectedScreenId) {
          return this.$toasted.show("Please Select Screen");
        } else {
          let loader = this.$loading.show();

          let payload = {
            MultiScheduleArray: filteredMultiSchedule,
            CinemasSettings: this.CinemasSettings,
            timeZone: this.timeZone,
            screen_id: this.selectedScreenId,
            cinema_id: this.scheduleObject.cinema_id,
            fromDate: moment(this.movieSelected.ss_start_date).format(
              "YYYY-MM-DD"
            ),
            toDate: moment(this.movieSelected.ss_end_date).format("YYYY-MM-DD"),
          };
          this.submitted = true;

          console.log("payload", payload);

          scheduleService
            .InsertMultiSchedule(payload)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                this.$toasted.show(data.message);
                this.getAllScheduleDetails();
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              this.checkForUnsavedChanges = false;
              this.submitted = false;
              loader.hide();
            });
        }
      },
    },
  };
</script>

<style>
  .add-multiple-schedule {
    zoom: 0.85;
  }
  .add-multiple-schedule .movie-version-box {
    padding: 1rem !important;
    border: none !important;
  }
  .add-multiple-schedule .movie-version-inner {
    /* padding: 0.5rem; */
    padding: 0.8rem;
    margin-bottom: 1rem;
    border: none !important;
  }
  .add-multi-inner {
    border: 2px solid #a1a1a4;
    border-radius: 08px;
    padding: 0.5rem 0 0.5rem 0.5rem;
    margin-bottom: 1rem;
  }
  .add-multiple-schedule .movie-version-inner .input-material input,
  .add-multiple-schedule
    .movie-version-inner
    .input-material-textarea
    textarea {
    background-color: #fff !important;
  }
  .multiselect__option--selected .ssmv-red-color,
  .multiselect__option--highlight .ssmv-red-color {
    color: white;
  }
  .time_picker_custom input {
    background-color: #ffffff !important;
    color: #000 !important;
  }
  .time_picker_custom label {
    left: 15px;
    top: 10px;
    z-index: 11;
    outline: none;
    margin-bottom: 0;
    padding: 0 5px;
    font-size: 14px;
    position: absolute;
    font-weight: 600;
    pointer-events: none;
    background-color: #fff;
    transition: 300ms ease all;
  }
  .time_picker_custom .shift-up {
    /* z-index: 3; */
    background: linear-gradient(var(--lightgrey), white) !important;
    margin-bottom: 0px;
    top: -7px !important;
    position: absolute;
    font-size: 12px !important;
    /* left: 20px !important; */
  }
  /* .custom_movie_selector .multiselect__single {
  max-height: 10px;
  max-width: 110px;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
} */

  .movieVersionTag {
    background: white;
    position: absolute;
    right: 0px;
    top: 10px;
    font-size: 10px !important;
    padding-right: 15px;
    padding-left: 9px;
  }

  .custom_movie_selector .multiselect__content {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .movieNameTag {
    width: 210px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .no-date-shift {
    margin-top: -25px;
    margin-bottom: 7px;
    margin-left: -15px;
  }

  .date-shift {
    margin-top: -25px;
    margin-bottom: 7px;
    margin-left: -26px;
    margin-right: -26px;
    display: flex;
    gap: 3px;
  }

  .timepicker-label {
    margin-top: -20px;
    font-size: 12px;
    font-weight: bold;
  }

  .movieBox-multi {
    width: 95%;
    padding-right: 15px;
    padding-left: 15px;
  }

  .planned-checked
    input[type="checkbox"]:checked
    ~ .custom-control-label::before {
    background: #ffe700 url("../../../../assets/img/icons/tick-yellow.svg")
      no-repeat center center;
    background-size: 22px;
    border: none !important;
  }

  .planned-checked
    .custom-checkbox
    .custom-control-input:disabled:checked
    ~ .custom-control-label::before {
    background-color: #ffe700 !important;
  }

  .checkBoxDisable {
    opacity: 0.5;
  }

  .addBtn_multi:focus-visible {
    transform: scale(1.5) !important;
  }

  .padTop-18 {
    padding-top: 18px !important;
  }

  .slick-input input,
  .slick-input .time_picker input,
  .slick-input .display-time {
    height: 30px !important;
    width: 87px !important;
    border-radius: 5px !important;
  }

  .slick-input .vue__time-picker {
    width: 85px !important;
  }

  .slick-input .vue__time-picker .controls .char {
    font-size: 1.3rem !important;
  }

  .show_time_row:nth-child(odd) {
    background-color: white !important;
  }

  .show_time_row:nth-child(even) {
    background-color: #e5e5ff61 !important;
  }

  .show_time_row {
    padding: 2px 10px 2px 0px;
    border-radius: 10px 0px 0px 10px;
  }

  .movieBox-multi .multiselect {
    min-height: 38px !important;
  }

  .movieBox-multi .multiselect__tags {
    min-height: 35px !important;
    border-radius: 5px !important;
  }

  .movieBox-multi .multiselect__single {
    font-size: 13px !important;
  }

  .movieBox-multi .multiselect__option {
    line-height: 13px !important;
  }

  .movieBox-multi .multiselect__placeholder {
    font-size: 12px;
  }

  .schduleTypeBtn {
    height: 20px;
    width: 20px;
    border: 1px solid grey;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .schduleTypeBtn-transparent {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .type16 {
    background-color: #32bea6;
    color: white;
    border-color: #32bea6;
  }

  .type19 {
    background-color: #ffe700;
    color: white;
    border-color: #ffe700;
  }
  .ZoomClass9 {
    zoom: 0.85;
  }

  .overlapError .custom-control-label::before,
  .overlapError .j-checkbox .custom-control-label::before {
    border: 2px solid #e14949 !important;
    content: "O";
    font-weight: 600;
    font-size: 14px;
    color: #ff0000 !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .rateCardError .custom-control-label::before,
  .rateCardError .j-checkbox .custom-control-label::before {
    border: 2px solid rgb(210 141 249) !important;
    content: "R";
    font-weight: 600;
    font-size: 14px;
    color: rgb(210 141 249) !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .plannedToSchedule .custom-control-label::before,
  .plannedToSchedule .j-checkbox .custom-control-label::before {
    border: 2px solid #32bea6 !important;
    background-color: #32bea6;
    content: "S";
    font-weight: 500;
    font-size: 14px;
    color: white !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .scheduleToPlanned .custom-control-label::before,
  .scheduleToPlanned .j-checkbox .custom-control-label::before {
    border: 2px solid #ffe700 !important;
    background-color: #ffe700;
    content: "P";
    font-weight: 500;
    font-size: 14px;
    color: white !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .screen-popover {
    font-size: 10px;
    min-width: 260px !important;
    zoom: 0.9;
  }

  #unsavedConfirmation___BV_modal_header_ {
    height: 34px;
    display: flex;
    align-items: center;
  }

  .key-box {
    color: black;
    padding-inline: 10px;
    border-radius: 5px;
    border: 1px solid grey;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  /* @media (max-width: 1400px) {
  .add-multiple-schedule {
    zoom: 0.65 !important;
  }
} */

  @media screen and (min-width: 1025px) and (max-width: 1480px) {
    .add-multiple-schedule {
      zoom: 0.65 !important;
    }
  }

  @media screen and (min-width: 1400px) and (max-width: 1480px) {
    .mln18 {
      margin-left: -60px !important;
    }
  }

  @media screen and (min-width: 1300px) and (max-width: 1400px) {
    .mln18 {
      margin-left: -40px !important;
    }
  }

  @media (max-width: 1025px) {
    .add-multiple-schedule {
      zoom: 0.45 !important;
    }
  }

  @media (min-width: 1200px) {
    .mln18 {
      margin-left: -18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MultiScheduleComponents/addMultiScheduleV3.vue